/* @generated from adl module ferovinum.app.expenses */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './db';

/**
 * Data for a single expense to be booked
 */
export interface ExpenseBookingData {
  expenseTypeCode: ferovinum_app_db.ExpenseTypeCode;
  description: common_strings.StringNE;
  value: common.BigDecimal;
  notes: (common_strings.StringMD|null);
  vendor: (common_strings.StringNE|null);
  vendorReference: (common_strings.StringNE|null);
}

export function makeExpenseBookingData(
  input: {
    expenseTypeCode: ferovinum_app_db.ExpenseTypeCode,
    description: common_strings.StringNE,
    value: common.BigDecimal,
    notes: (common_strings.StringMD|null),
    vendor: (common_strings.StringNE|null),
    vendorReference: (common_strings.StringNE|null),
  }
): ExpenseBookingData {
  return {
    expenseTypeCode: input.expenseTypeCode,
    description: input.description,
    value: input.value,
    notes: input.notes,
    vendor: input.vendor,
    vendorReference: input.vendorReference,
  };
}

const ExpenseBookingData_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[{"value":"Data for a single expense to be booked\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"expenseTypeCode","default":{"kind":"nothing"},"name":"expenseTypeCode","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseTypeCode"}},"parameters":[]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"notes","default":{"kind":"nothing"},"name":"notes","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringMD"}},"parameters":[]}]}},{"annotations":[],"serializedName":"vendor","default":{"kind":"nothing"},"name":"vendor","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"vendorReference","default":{"kind":"nothing"},"name":"vendorReference","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"ExpenseBookingData","version":{"kind":"nothing"}}};

export const snExpenseBookingData: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"ExpenseBookingData"};

export function texprExpenseBookingData(): ADL.ATypeExpr<ExpenseBookingData> {
  return {value : {typeRef : {kind: "reference", value : snExpenseBookingData}, parameters : []}};
}

export interface ExpenseBookingOrigin_SaleOrder {
  kind: 'saleOrder';
  value: ferovinum_app_db.SaleOrderId;
}
export interface ExpenseBookingOrigin_PurchaseRequest {
  kind: 'purchaseRequest';
  value: ferovinum_app_db.PurchaseRequestId;
}
export interface ExpenseBookingOrigin_ProductionOrder {
  kind: 'productionOrder';
  value: ferovinum_app_db.ProductionOrderTaskRunId;
}
export interface ExpenseBookingOrigin_Manual {
  kind: 'manual';
}

export type ExpenseBookingOrigin = ExpenseBookingOrigin_SaleOrder | ExpenseBookingOrigin_PurchaseRequest | ExpenseBookingOrigin_ProductionOrder | ExpenseBookingOrigin_Manual;

export interface ExpenseBookingOriginOpts {
  saleOrder: ferovinum_app_db.SaleOrderId;
  purchaseRequest: ferovinum_app_db.PurchaseRequestId;
  productionOrder: ferovinum_app_db.ProductionOrderTaskRunId;
  manual: null;
}

export function makeExpenseBookingOrigin<K extends keyof ExpenseBookingOriginOpts>(kind: K, value: ExpenseBookingOriginOpts[K]) { return {kind, value}; }

const ExpenseBookingOrigin_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"saleOrder","default":{"kind":"nothing"},"name":"saleOrder","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"SaleOrderId"}},"parameters":[]}},{"annotations":[],"serializedName":"purchaseRequest","default":{"kind":"nothing"},"name":"purchaseRequest","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PurchaseRequestId"}},"parameters":[]}},{"annotations":[],"serializedName":"productionOrder","default":{"kind":"nothing"},"name":"productionOrder","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductionOrderTaskRunId"}},"parameters":[]}},{"annotations":[],"serializedName":"manual","default":{"kind":"nothing"},"name":"manual","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"ExpenseBookingOrigin","version":{"kind":"nothing"}}};

export const snExpenseBookingOrigin: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"ExpenseBookingOrigin"};

export function texprExpenseBookingOrigin(): ADL.ATypeExpr<ExpenseBookingOrigin> {
  return {value : {typeRef : {kind: "reference", value : snExpenseBookingOrigin}, parameters : []}};
}

/**
 * Configuration for capex distribution
 */
export interface ExpenseCapexConfig {
  spreadType: ferovinum_app_db.CapitalisedExpenseSpreadType;
  application: ferovinum_app_db.CapitalisedExpenseApplication;
  valueAccretive: boolean;
  excludeFinishedProducts: boolean;
  excludeUnavailableDealLeg: boolean;
}

export function makeExpenseCapexConfig(
  input: {
    spreadType: ferovinum_app_db.CapitalisedExpenseSpreadType,
    application: ferovinum_app_db.CapitalisedExpenseApplication,
    valueAccretive: boolean,
    excludeFinishedProducts?: boolean,
    excludeUnavailableDealLeg?: boolean,
  }
): ExpenseCapexConfig {
  return {
    spreadType: input.spreadType,
    application: input.application,
    valueAccretive: input.valueAccretive,
    excludeFinishedProducts: input.excludeFinishedProducts === undefined ? false : input.excludeFinishedProducts,
    excludeUnavailableDealLeg: input.excludeUnavailableDealLeg === undefined ? false : input.excludeUnavailableDealLeg,
  };
}

const ExpenseCapexConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[{"value":"Configuration for capex distribution\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"spreadType","default":{"kind":"nothing"},"name":"spreadType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"CapitalisedExpenseSpreadType"}},"parameters":[]}},{"annotations":[],"serializedName":"application","default":{"kind":"nothing"},"name":"application","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"CapitalisedExpenseApplication"}},"parameters":[]}},{"annotations":[],"serializedName":"valueAccretive","default":{"kind":"nothing"},"name":"valueAccretive","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"excludeFinishedProducts","default":{"kind":"just","value":false},"name":"excludeFinishedProducts","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"excludeUnavailableDealLeg","default":{"kind":"just","value":false},"name":"excludeUnavailableDealLeg","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"ExpenseCapexConfig","version":{"kind":"nothing"}}};

export const snExpenseCapexConfig: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"ExpenseCapexConfig"};

export function texprExpenseCapexConfig(): ADL.ATypeExpr<ExpenseCapexConfig> {
  return {value : {typeRef : {kind: "reference", value : snExpenseCapexConfig}, parameters : []}};
}

export interface ExpenseCapexBinding_CreateCapex {
  kind: 'CreateCapex';
  value: ExpenseCapexConfig;
}
export interface ExpenseCapexBinding_AttachToExisting {
  kind: 'AttachToExisting';
  value: ferovinum_app_db.CapitalisedExpenseDescriptionId;
}

/**
 * How a funded expense binds to a capex description
 */
export type ExpenseCapexBinding = ExpenseCapexBinding_CreateCapex | ExpenseCapexBinding_AttachToExisting;

export interface ExpenseCapexBindingOpts {
  CreateCapex: ExpenseCapexConfig;
  AttachToExisting: ferovinum_app_db.CapitalisedExpenseDescriptionId;
}

export function makeExpenseCapexBinding<K extends keyof ExpenseCapexBindingOpts>(kind: K, value: ExpenseCapexBindingOpts[K]) { return {kind, value}; }

const ExpenseCapexBinding_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[{"value":"How a funded expense binds to a capex description\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"CreateCapex","default":{"kind":"nothing"},"name":"CreateCapex","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"ExpenseCapexConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"AttachToExisting","default":{"kind":"nothing"},"name":"AttachToExisting","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"CapitalisedExpenseDescriptionId"}},"parameters":[]}}]}},"name":"ExpenseCapexBinding","version":{"kind":"nothing"}}};

export const snExpenseCapexBinding: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"ExpenseCapexBinding"};

export function texprExpenseCapexBinding(): ADL.ATypeExpr<ExpenseCapexBinding> {
  return {value : {typeRef : {kind: "reference", value : snExpenseCapexBinding}, parameters : []}};
}

export interface RechargeBinding_None {
  kind: 'None';
}
export interface RechargeBinding_CreateInvoice {
  kind: 'CreateInvoice';
}
export interface RechargeBinding_ExistingInvoice {
  kind: 'ExistingInvoice';
  value: ferovinum_app_db.InvoiceLineItemId;
}

/**
 * How a recharge expense binds to an invoice
 */
export type RechargeBinding = RechargeBinding_None | RechargeBinding_CreateInvoice | RechargeBinding_ExistingInvoice;

export interface RechargeBindingOpts {
  None: null;
  CreateInvoice: null;
  ExistingInvoice: ferovinum_app_db.InvoiceLineItemId;
}

export function makeRechargeBinding<K extends keyof RechargeBindingOpts>(kind: K, value: RechargeBindingOpts[K]) { return {kind, value}; }

const RechargeBinding_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[{"value":"How a recharge expense binds to an invoice\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"None","default":{"kind":"nothing"},"name":"None","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"CreateInvoice","default":{"kind":"nothing"},"name":"CreateInvoice","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"ExistingInvoice","default":{"kind":"nothing"},"name":"ExistingInvoice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"InvoiceLineItemId"}},"parameters":[]}}]}},"name":"RechargeBinding","version":{"kind":"nothing"}}};

export const snRechargeBinding: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"RechargeBinding"};

export function texprRechargeBinding(): ADL.ATypeExpr<RechargeBinding> {
  return {value : {typeRef : {kind: "reference", value : snRechargeBinding}, parameters : []}};
}

/**
 * Pairs an expense with its invoice binding
 */
export interface RechargeEntry {
  expense: ExpenseBookingData;
  binding: RechargeBinding;
  attachments: ferovinum_app_db.StoredFileId[];
  /**
   * Original CSV row number. Null when created via the single-booking UI.
   */
  sourceRowIndex: (number|null);
}

export function makeRechargeEntry(
  input: {
    expense: ExpenseBookingData,
    binding: RechargeBinding,
    attachments: ferovinum_app_db.StoredFileId[],
    sourceRowIndex?: (number|null),
  }
): RechargeEntry {
  return {
    expense: input.expense,
    binding: input.binding,
    attachments: input.attachments,
    sourceRowIndex: input.sourceRowIndex === undefined ? null : input.sourceRowIndex,
  };
}

const RechargeEntry_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[{"value":"Pairs an expense with its invoice binding\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"expense","default":{"kind":"nothing"},"name":"expense","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"ExpenseBookingData"}},"parameters":[]}},{"annotations":[],"serializedName":"binding","default":{"kind":"nothing"},"name":"binding","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"RechargeBinding"}},"parameters":[]}},{"annotations":[],"serializedName":"attachments","default":{"kind":"nothing"},"name":"attachments","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StoredFileId"}},"parameters":[]}]}},{"annotations":[{"value":"Original CSV row number. Null when created via the single-booking UI.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"sourceRowIndex","default":{"kind":"just","value":null},"name":"sourceRowIndex","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}]}}]}},"name":"RechargeEntry","version":{"kind":"nothing"}}};

export const snRechargeEntry: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"RechargeEntry"};

export function texprRechargeEntry(): ADL.ATypeExpr<RechargeEntry> {
  return {value : {typeRef : {kind: "reference", value : snRechargeEntry}, parameters : []}};
}

/**
 * Books recharge expenses with flexible invoice binding per entry
 */
export interface BookRechargeReq {
  organisationId: ferovinum_app_db.OrganisationId;
  expenseDate: common.LocalDate;
  dueDate: common.LocalDate;
  currency: ferovinum_app_db.Currency;
  feroEntity: ferovinum_app_db.FeroEntity;
  origin: ExpenseBookingOrigin;
  entries: RechargeEntry[];
}

export function makeBookRechargeReq(
  input: {
    organisationId: ferovinum_app_db.OrganisationId,
    expenseDate: common.LocalDate,
    dueDate: common.LocalDate,
    currency: ferovinum_app_db.Currency,
    feroEntity: ferovinum_app_db.FeroEntity,
    origin: ExpenseBookingOrigin,
    entries: RechargeEntry[],
  }
): BookRechargeReq {
  return {
    organisationId: input.organisationId,
    expenseDate: input.expenseDate,
    dueDate: input.dueDate,
    currency: input.currency,
    feroEntity: input.feroEntity,
    origin: input.origin,
    entries: input.entries,
  };
}

const BookRechargeReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[{"value":"Books recharge expenses with flexible invoice binding per entry\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseDate","default":{"kind":"nothing"},"name":"expenseDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"dueDate","default":{"kind":"nothing"},"name":"dueDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Currency"}},"parameters":[]}},{"annotations":[],"serializedName":"feroEntity","default":{"kind":"nothing"},"name":"feroEntity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"FeroEntity"}},"parameters":[]}},{"annotations":[],"serializedName":"origin","default":{"kind":"nothing"},"name":"origin","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"ExpenseBookingOrigin"}},"parameters":[]}},{"annotations":[],"serializedName":"entries","default":{"kind":"nothing"},"name":"entries","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"RechargeEntry"}},"parameters":[]}]}}]}},"name":"BookRechargeReq","version":{"kind":"nothing"}}};

export const snBookRechargeReq: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"BookRechargeReq"};

export function texprBookRechargeReq(): ADL.ATypeExpr<BookRechargeReq> {
  return {value : {typeRef : {kind: "reference", value : snBookRechargeReq}, parameters : []}};
}

export interface UpdateExpenseEntry {
  expenseId: ferovinum_app_db.ExpenseId;
  vendor: (common_strings.StringNE|null);
  vendorReference: (common_strings.StringNE|null);
  description: common_strings.StringNE;
}

export function makeUpdateExpenseEntry(
  input: {
    expenseId: ferovinum_app_db.ExpenseId,
    vendor: (common_strings.StringNE|null),
    vendorReference: (common_strings.StringNE|null),
    description: common_strings.StringNE,
  }
): UpdateExpenseEntry {
  return {
    expenseId: input.expenseId,
    vendor: input.vendor,
    vendorReference: input.vendorReference,
    description: input.description,
  };
}

const UpdateExpenseEntry_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"expenseId","default":{"kind":"nothing"},"name":"expenseId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseId"}},"parameters":[]}},{"annotations":[],"serializedName":"vendor","default":{"kind":"nothing"},"name":"vendor","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"vendorReference","default":{"kind":"nothing"},"name":"vendorReference","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"UpdateExpenseEntry","version":{"kind":"nothing"}}};

export const snUpdateExpenseEntry: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"UpdateExpenseEntry"};

export function texprUpdateExpenseEntry(): ADL.ATypeExpr<UpdateExpenseEntry> {
  return {value : {typeRef : {kind: "reference", value : snUpdateExpenseEntry}, parameters : []}};
}

export interface UpdateExpensesReq {
  entries: UpdateExpenseEntry[];
}

export function makeUpdateExpensesReq(
  input: {
    entries: UpdateExpenseEntry[],
  }
): UpdateExpensesReq {
  return {
    entries: input.entries,
  };
}

const UpdateExpensesReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"entries","default":{"kind":"nothing"},"name":"entries","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"UpdateExpenseEntry"}},"parameters":[]}]}}]}},"name":"UpdateExpensesReq","version":{"kind":"nothing"}}};

export const snUpdateExpensesReq: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"UpdateExpensesReq"};

export function texprUpdateExpensesReq(): ADL.ATypeExpr<UpdateExpensesReq> {
  return {value : {typeRef : {kind: "reference", value : snUpdateExpensesReq}, parameters : []}};
}

export interface UpdateExpensesResp {
}

export function makeUpdateExpensesResp(
  _input: {
  }
): UpdateExpensesResp {
  return {
  };
}

const UpdateExpensesResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"UpdateExpensesResp","version":{"kind":"nothing"}}};

export const snUpdateExpensesResp: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"UpdateExpensesResp"};

export function texprUpdateExpensesResp(): ADL.ATypeExpr<UpdateExpensesResp> {
  return {value : {typeRef : {kind: "reference", value : snUpdateExpensesResp}, parameters : []}};
}

export interface CapexEntry {
  expense: ExpenseBookingData;
  attachments: ferovinum_app_db.StoredFileId[];
}

export function makeCapexEntry(
  input: {
    expense: ExpenseBookingData,
    attachments: ferovinum_app_db.StoredFileId[],
  }
): CapexEntry {
  return {
    expense: input.expense,
    attachments: input.attachments,
  };
}

const CapexEntry_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"expense","default":{"kind":"nothing"},"name":"expense","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"ExpenseBookingData"}},"parameters":[]}},{"annotations":[],"serializedName":"attachments","default":{"kind":"nothing"},"name":"attachments","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StoredFileId"}},"parameters":[]}]}}]}},"name":"CapexEntry","version":{"kind":"nothing"}}};

export const snCapexEntry: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"CapexEntry"};

export function texprCapexEntry(): ADL.ATypeExpr<CapexEntry> {
  return {value : {typeRef : {kind: "reference", value : snCapexEntry}, parameters : []}};
}

export interface BookCapexReq {
  organisationId: ferovinum_app_db.OrganisationId;
  expenseDate: common.LocalDate;
  currency: ferovinum_app_db.Currency;
  feroEntity: ferovinum_app_db.FeroEntity;
  origin: ExpenseBookingOrigin;
  capexBinding: ExpenseCapexBinding;
  entries: CapexEntry[];
  /**
   * Original CSV row number. Null when created via the single-booking UI.
   */
  sourceRowIndex: (number|null);
}

export function makeBookCapexReq(
  input: {
    organisationId: ferovinum_app_db.OrganisationId,
    expenseDate: common.LocalDate,
    currency: ferovinum_app_db.Currency,
    feroEntity: ferovinum_app_db.FeroEntity,
    origin: ExpenseBookingOrigin,
    capexBinding: ExpenseCapexBinding,
    entries: CapexEntry[],
    sourceRowIndex?: (number|null),
  }
): BookCapexReq {
  return {
    organisationId: input.organisationId,
    expenseDate: input.expenseDate,
    currency: input.currency,
    feroEntity: input.feroEntity,
    origin: input.origin,
    capexBinding: input.capexBinding,
    entries: input.entries,
    sourceRowIndex: input.sourceRowIndex === undefined ? null : input.sourceRowIndex,
  };
}

const BookCapexReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseDate","default":{"kind":"nothing"},"name":"expenseDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Currency"}},"parameters":[]}},{"annotations":[],"serializedName":"feroEntity","default":{"kind":"nothing"},"name":"feroEntity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"FeroEntity"}},"parameters":[]}},{"annotations":[],"serializedName":"origin","default":{"kind":"nothing"},"name":"origin","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"ExpenseBookingOrigin"}},"parameters":[]}},{"annotations":[],"serializedName":"capexBinding","default":{"kind":"nothing"},"name":"capexBinding","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"ExpenseCapexBinding"}},"parameters":[]}},{"annotations":[],"serializedName":"entries","default":{"kind":"nothing"},"name":"entries","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"CapexEntry"}},"parameters":[]}]}},{"annotations":[{"value":"Original CSV row number. Null when created via the single-booking UI.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"sourceRowIndex","default":{"kind":"just","value":null},"name":"sourceRowIndex","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}]}}]}},"name":"BookCapexReq","version":{"kind":"nothing"}}};

export const snBookCapexReq: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"BookCapexReq"};

export function texprBookCapexReq(): ADL.ATypeExpr<BookCapexReq> {
  return {value : {typeRef : {kind: "reference", value : snBookCapexReq}, parameters : []}};
}

export interface BookPurchaseRequestExpensesReq {
  organisationId: ferovinum_app_db.OrganisationId;
  expenseDate: common.LocalDate;
  currency: ferovinum_app_db.Currency;
  feroEntity: ferovinum_app_db.FeroEntity;
  origin: ExpenseBookingOrigin;
  purchaseRequestId: ferovinum_app_db.PurchaseRequestId;
  expenses: ExpenseBookingData[];
}

export function makeBookPurchaseRequestExpensesReq(
  input: {
    organisationId: ferovinum_app_db.OrganisationId,
    expenseDate: common.LocalDate,
    currency: ferovinum_app_db.Currency,
    feroEntity: ferovinum_app_db.FeroEntity,
    origin: ExpenseBookingOrigin,
    purchaseRequestId: ferovinum_app_db.PurchaseRequestId,
    expenses: ExpenseBookingData[],
  }
): BookPurchaseRequestExpensesReq {
  return {
    organisationId: input.organisationId,
    expenseDate: input.expenseDate,
    currency: input.currency,
    feroEntity: input.feroEntity,
    origin: input.origin,
    purchaseRequestId: input.purchaseRequestId,
    expenses: input.expenses,
  };
}

const BookPurchaseRequestExpensesReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseDate","default":{"kind":"nothing"},"name":"expenseDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Currency"}},"parameters":[]}},{"annotations":[],"serializedName":"feroEntity","default":{"kind":"nothing"},"name":"feroEntity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"FeroEntity"}},"parameters":[]}},{"annotations":[],"serializedName":"origin","default":{"kind":"nothing"},"name":"origin","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"ExpenseBookingOrigin"}},"parameters":[]}},{"annotations":[],"serializedName":"purchaseRequestId","default":{"kind":"nothing"},"name":"purchaseRequestId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PurchaseRequestId"}},"parameters":[]}},{"annotations":[],"serializedName":"expenses","default":{"kind":"nothing"},"name":"expenses","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"ExpenseBookingData"}},"parameters":[]}]}}]}},"name":"BookPurchaseRequestExpensesReq","version":{"kind":"nothing"}}};

export const snBookPurchaseRequestExpensesReq: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"BookPurchaseRequestExpensesReq"};

export function texprBookPurchaseRequestExpensesReq(): ADL.ATypeExpr<BookPurchaseRequestExpensesReq> {
  return {value : {typeRef : {kind: "reference", value : snBookPurchaseRequestExpensesReq}, parameters : []}};
}

/**
 * Support-only request to hard-delete capitalised expenses and their backing capex records.
 * Validated server-side: each expense must be a capex (funded) expense, its capex description
 * must not be shared with another expense, its capex must not have been rolled forward onto
 * another deal leg, and no sale may have been made on a spread deal leg at/after the capex was
 * booked (compared at instant resolution against the capex created_at).
 */
export interface DeleteCapexReq {
  expenseIds: ferovinum_app_db.ExpenseId[];
}

export function makeDeleteCapexReq(
  input: {
    expenseIds: ferovinum_app_db.ExpenseId[],
  }
): DeleteCapexReq {
  return {
    expenseIds: input.expenseIds,
  };
}

const DeleteCapexReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[{"value":"Support-only request to hard-delete capitalised expenses and their backing capex records.\nValidated server-side: each expense must be a capex (funded) expense, its capex description\nmust not be shared with another expense, its capex must not have been rolled forward onto\nanother deal leg, and no sale may have been made on a spread deal leg at/after the capex was\nbooked (compared at instant resolution against the capex created_at).\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"expenseIds","default":{"kind":"nothing"},"name":"expenseIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseId"}},"parameters":[]}]}}]}},"name":"DeleteCapexReq","version":{"kind":"nothing"}}};

export const snDeleteCapexReq: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"DeleteCapexReq"};

export function texprDeleteCapexReq(): ADL.ATypeExpr<DeleteCapexReq> {
  return {value : {typeRef : {kind: "reference", value : snDeleteCapexReq}, parameters : []}};
}

export interface BookRechargeResp {
  invoiceId: (ferovinum_app_db.InvoiceId|null);
  expenseIds: ferovinum_app_db.ExpenseId[];
}

export function makeBookRechargeResp(
  input: {
    invoiceId: (ferovinum_app_db.InvoiceId|null),
    expenseIds: ferovinum_app_db.ExpenseId[],
  }
): BookRechargeResp {
  return {
    invoiceId: input.invoiceId,
    expenseIds: input.expenseIds,
  };
}

const BookRechargeResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"invoiceId","default":{"kind":"nothing"},"name":"invoiceId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"InvoiceId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"expenseIds","default":{"kind":"nothing"},"name":"expenseIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseId"}},"parameters":[]}]}}]}},"name":"BookRechargeResp","version":{"kind":"nothing"}}};

export const snBookRechargeResp: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"BookRechargeResp"};

export function texprBookRechargeResp(): ADL.ATypeExpr<BookRechargeResp> {
  return {value : {typeRef : {kind: "reference", value : snBookRechargeResp}, parameters : []}};
}

export interface BookCapexResp {
  capexDescriptionId: ferovinum_app_db.CapitalisedExpenseDescriptionId;
  expenseIds: ferovinum_app_db.ExpenseId[];
}

export function makeBookCapexResp(
  input: {
    capexDescriptionId: ferovinum_app_db.CapitalisedExpenseDescriptionId,
    expenseIds: ferovinum_app_db.ExpenseId[],
  }
): BookCapexResp {
  return {
    capexDescriptionId: input.capexDescriptionId,
    expenseIds: input.expenseIds,
  };
}

const BookCapexResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"capexDescriptionId","default":{"kind":"nothing"},"name":"capexDescriptionId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"CapitalisedExpenseDescriptionId"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseIds","default":{"kind":"nothing"},"name":"expenseIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseId"}},"parameters":[]}]}}]}},"name":"BookCapexResp","version":{"kind":"nothing"}}};

export const snBookCapexResp: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"BookCapexResp"};

export function texprBookCapexResp(): ADL.ATypeExpr<BookCapexResp> {
  return {value : {typeRef : {kind: "reference", value : snBookCapexResp}, parameters : []}};
}

export interface DeleteCapexResp {
  deletedExpenseIds: ferovinum_app_db.ExpenseId[];
  deletedCapexDescriptionIds: ferovinum_app_db.CapitalisedExpenseDescriptionId[];
  /**
   * Number of capitalised_expense spread rows removed.
   */
  deletedCapexEntries: number;
  /**
   * Number of auto-generated capex spread CSV files (stored_file rows) removed.
   */
  deletedSpreadCsvs: number;
}

export function makeDeleteCapexResp(
  input: {
    deletedExpenseIds: ferovinum_app_db.ExpenseId[],
    deletedCapexDescriptionIds: ferovinum_app_db.CapitalisedExpenseDescriptionId[],
    deletedCapexEntries: number,
    deletedSpreadCsvs: number,
  }
): DeleteCapexResp {
  return {
    deletedExpenseIds: input.deletedExpenseIds,
    deletedCapexDescriptionIds: input.deletedCapexDescriptionIds,
    deletedCapexEntries: input.deletedCapexEntries,
    deletedSpreadCsvs: input.deletedSpreadCsvs,
  };
}

const DeleteCapexResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"deletedExpenseIds","default":{"kind":"nothing"},"name":"deletedExpenseIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"deletedCapexDescriptionIds","default":{"kind":"nothing"},"name":"deletedCapexDescriptionIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"CapitalisedExpenseDescriptionId"}},"parameters":[]}]}},{"annotations":[{"value":"Number of capitalised_expense spread rows removed.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"deletedCapexEntries","default":{"kind":"nothing"},"name":"deletedCapexEntries","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[{"value":"Number of auto-generated capex spread CSV files (stored_file rows) removed.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"deletedSpreadCsvs","default":{"kind":"nothing"},"name":"deletedSpreadCsvs","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"DeleteCapexResp","version":{"kind":"nothing"}}};

export const snDeleteCapexResp: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"DeleteCapexResp"};

export function texprDeleteCapexResp(): ADL.ATypeExpr<DeleteCapexResp> {
  return {value : {typeRef : {kind: "reference", value : snDeleteCapexResp}, parameters : []}};
}

export interface BookPurchaseRequestExpensesResp {
  purchaseRequestId: ferovinum_app_db.PurchaseRequestId;
  expenseIds: ferovinum_app_db.ExpenseId[];
}

export function makeBookPurchaseRequestExpensesResp(
  input: {
    purchaseRequestId: ferovinum_app_db.PurchaseRequestId,
    expenseIds: ferovinum_app_db.ExpenseId[],
  }
): BookPurchaseRequestExpensesResp {
  return {
    purchaseRequestId: input.purchaseRequestId,
    expenseIds: input.expenseIds,
  };
}

const BookPurchaseRequestExpensesResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"purchaseRequestId","default":{"kind":"nothing"},"name":"purchaseRequestId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PurchaseRequestId"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseIds","default":{"kind":"nothing"},"name":"expenseIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseId"}},"parameters":[]}]}}]}},"name":"BookPurchaseRequestExpensesResp","version":{"kind":"nothing"}}};

export const snBookPurchaseRequestExpensesResp: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"BookPurchaseRequestExpensesResp"};

export function texprBookPurchaseRequestExpensesResp(): ADL.ATypeExpr<BookPurchaseRequestExpensesResp> {
  return {value : {typeRef : {kind: "reference", value : snBookPurchaseRequestExpensesResp}, parameters : []}};
}

export type SortDirection = 'Asc' | 'Desc';
export const valuesSortDirection : SortDirection[] = ['Asc', 'Desc'];

const SortDirection_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"Asc","default":{"kind":"nothing"},"name":"Asc","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Desc","default":{"kind":"nothing"},"name":"Desc","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"SortDirection","version":{"kind":"nothing"}}};

export const snSortDirection: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"SortDirection"};

export function texprSortDirection(): ADL.ATypeExpr<SortDirection> {
  return {value : {typeRef : {kind: "reference", value : snSortDirection}, parameters : []}};
}

export interface SortParam<F> {
  field: F;
  direction: SortDirection;
}

export function makeSortParam<F>(
  input: {
    field: F,
    direction: SortDirection,
  }
): SortParam<F> {
  return {
    field: input.field,
    direction: input.direction,
  };
}

const SortParam_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":["F"],"fields":[{"annotations":[],"serializedName":"field","default":{"kind":"nothing"},"name":"field","typeExpr":{"typeRef":{"kind":"typeParam","value":"F"},"parameters":[]}},{"annotations":[],"serializedName":"direction","default":{"kind":"nothing"},"name":"direction","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"SortDirection"}},"parameters":[]}}]}},"name":"SortParam","version":{"kind":"nothing"}}};

export const snSortParam: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"SortParam"};

export function texprSortParam<F>(texprF : ADL.ATypeExpr<F>): ADL.ATypeExpr<SortParam<F>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "ferovinum.app.expenses",name : "SortParam"}}, parameters : [texprF.value]}};
}

export interface PaginationParam {
  offset: number;
  count: number;
}

export function makePaginationParam(
  input: {
    offset?: number,
    count?: number,
  }
): PaginationParam {
  return {
    offset: input.offset === undefined ? 0 : input.offset,
    count: input.count === undefined ? 20 : input.count,
  };
}

const PaginationParam_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"offset","default":{"kind":"just","value":0},"name":"offset","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"count","default":{"kind":"just","value":20},"name":"count","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"PaginationParam","version":{"kind":"nothing"}}};

export const snPaginationParam: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"PaginationParam"};

export function texprPaginationParam(): ADL.ATypeExpr<PaginationParam> {
  return {value : {typeRef : {kind: "reference", value : snPaginationParam}, parameters : []}};
}

export interface ExpenseVendorListReq {
  organisationId: (ferovinum_app_db.OrganisationId|null);
}

export function makeExpenseVendorListReq(
  input: {
    organisationId?: (ferovinum_app_db.OrganisationId|null),
  }
): ExpenseVendorListReq {
  return {
    organisationId: input.organisationId === undefined ? null : input.organisationId,
  };
}

const ExpenseVendorListReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"organisationId","default":{"kind":"just","value":null},"name":"organisationId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}]}}]}},"name":"ExpenseVendorListReq","version":{"kind":"nothing"}}};

export const snExpenseVendorListReq: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"ExpenseVendorListReq"};

export function texprExpenseVendorListReq(): ADL.ATypeExpr<ExpenseVendorListReq> {
  return {value : {typeRef : {kind: "reference", value : snExpenseVendorListReq}, parameters : []}};
}

export interface CapexCsvReportReq {
  organisationId: (ferovinum_app_db.OrganisationId|null);
  fromDate: common.LocalDate;
  toDate: common.LocalDate;
  expenseTypes: ferovinum_app_db.ExpenseTypeCode[];
  vendors: common_strings.StringNE[];
}

export function makeCapexCsvReportReq(
  input: {
    organisationId?: (ferovinum_app_db.OrganisationId|null),
    fromDate: common.LocalDate,
    toDate: common.LocalDate,
    expenseTypes?: ferovinum_app_db.ExpenseTypeCode[],
    vendors?: common_strings.StringNE[],
  }
): CapexCsvReportReq {
  return {
    organisationId: input.organisationId === undefined ? null : input.organisationId,
    fromDate: input.fromDate,
    toDate: input.toDate,
    expenseTypes: input.expenseTypes === undefined ? [] : input.expenseTypes,
    vendors: input.vendors === undefined ? [] : input.vendors,
  };
}

const CapexCsvReportReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"organisationId","default":{"kind":"just","value":null},"name":"organisationId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"fromDate","default":{"kind":"nothing"},"name":"fromDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"toDate","default":{"kind":"nothing"},"name":"toDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseTypes","default":{"kind":"just","value":[]},"name":"expenseTypes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseTypeCode"}},"parameters":[]}]}},{"annotations":[],"serializedName":"vendors","default":{"kind":"just","value":[]},"name":"vendors","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"CapexCsvReportReq","version":{"kind":"nothing"}}};

export const snCapexCsvReportReq: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"CapexCsvReportReq"};

export function texprCapexCsvReportReq(): ADL.ATypeExpr<CapexCsvReportReq> {
  return {value : {typeRef : {kind: "reference", value : snCapexCsvReportReq}, parameters : []}};
}

export interface RechargeCsvReportReq {
  organisationId: (ferovinum_app_db.OrganisationId|null);
  fromDate: common.LocalDate;
  toDate: common.LocalDate;
  tab: RechargeListTab;
  expenseTypes: ferovinum_app_db.ExpenseTypeCode[];
  vendors: common_strings.StringNE[];
}

export function makeRechargeCsvReportReq(
  input: {
    organisationId?: (ferovinum_app_db.OrganisationId|null),
    fromDate: common.LocalDate,
    toDate: common.LocalDate,
    tab?: RechargeListTab,
    expenseTypes?: ferovinum_app_db.ExpenseTypeCode[],
    vendors?: common_strings.StringNE[],
  }
): RechargeCsvReportReq {
  return {
    organisationId: input.organisationId === undefined ? null : input.organisationId,
    fromDate: input.fromDate,
    toDate: input.toDate,
    tab: input.tab === undefined ? "All" : input.tab,
    expenseTypes: input.expenseTypes === undefined ? [] : input.expenseTypes,
    vendors: input.vendors === undefined ? [] : input.vendors,
  };
}

const RechargeCsvReportReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"organisationId","default":{"kind":"just","value":null},"name":"organisationId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"fromDate","default":{"kind":"nothing"},"name":"fromDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"toDate","default":{"kind":"nothing"},"name":"toDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"tab","default":{"kind":"just","value":"All"},"name":"tab","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"RechargeListTab"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseTypes","default":{"kind":"just","value":[]},"name":"expenseTypes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseTypeCode"}},"parameters":[]}]}},{"annotations":[],"serializedName":"vendors","default":{"kind":"just","value":[]},"name":"vendors","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"RechargeCsvReportReq","version":{"kind":"nothing"}}};

export const snRechargeCsvReportReq: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"RechargeCsvReportReq"};

export function texprRechargeCsvReportReq(): ADL.ATypeExpr<RechargeCsvReportReq> {
  return {value : {typeRef : {kind: "reference", value : snRechargeCsvReportReq}, parameters : []}};
}

export type CapexListSortField = 'Reference' | 'Date' | 'Organisation' | 'Type' | 'Amount';
export const valuesCapexListSortField : CapexListSortField[] = ['Reference', 'Date', 'Organisation', 'Type', 'Amount'];

const CapexListSortField_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"Reference","default":{"kind":"nothing"},"name":"Reference","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Date","default":{"kind":"nothing"},"name":"Date","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Organisation","default":{"kind":"nothing"},"name":"Organisation","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Type","default":{"kind":"nothing"},"name":"Type","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Amount","default":{"kind":"nothing"},"name":"Amount","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"CapexListSortField","version":{"kind":"nothing"}}};

export const snCapexListSortField: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"CapexListSortField"};

export function texprCapexListSortField(): ADL.ATypeExpr<CapexListSortField> {
  return {value : {typeRef : {kind: "reference", value : snCapexListSortField}, parameters : []}};
}

export interface CapexListFilter {
  organisationId: (ferovinum_app_db.OrganisationId|null);
  expenseTypes: ferovinum_app_db.ExpenseTypeCode[];
  search: (common_strings.StringNE|null);
  fromDate: (common.LocalDate|null);
  toDate: (common.LocalDate|null);
  vendors: common_strings.StringNE[];
}

export function makeCapexListFilter(
  input: {
    organisationId?: (ferovinum_app_db.OrganisationId|null),
    expenseTypes?: ferovinum_app_db.ExpenseTypeCode[],
    search?: (common_strings.StringNE|null),
    fromDate?: (common.LocalDate|null),
    toDate?: (common.LocalDate|null),
    vendors?: common_strings.StringNE[],
  }
): CapexListFilter {
  return {
    organisationId: input.organisationId === undefined ? null : input.organisationId,
    expenseTypes: input.expenseTypes === undefined ? [] : input.expenseTypes,
    search: input.search === undefined ? null : input.search,
    fromDate: input.fromDate === undefined ? null : input.fromDate,
    toDate: input.toDate === undefined ? null : input.toDate,
    vendors: input.vendors === undefined ? [] : input.vendors,
  };
}

const CapexListFilter_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"organisationId","default":{"kind":"just","value":null},"name":"organisationId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"expenseTypes","default":{"kind":"just","value":[]},"name":"expenseTypes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseTypeCode"}},"parameters":[]}]}},{"annotations":[],"serializedName":"search","default":{"kind":"just","value":null},"name":"search","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"fromDate","default":{"kind":"just","value":null},"name":"fromDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"toDate","default":{"kind":"just","value":null},"name":"toDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"vendors","default":{"kind":"just","value":[]},"name":"vendors","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"CapexListFilter","version":{"kind":"nothing"}}};

export const snCapexListFilter: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"CapexListFilter"};

export function texprCapexListFilter(): ADL.ATypeExpr<CapexListFilter> {
  return {value : {typeRef : {kind: "reference", value : snCapexListFilter}, parameters : []}};
}

export interface CapexListReq {
  filter: CapexListFilter;
  pagination: PaginationParam;
  sort: (SortParam<CapexListSortField>|null);
}

export function makeCapexListReq(
  input: {
    filter: CapexListFilter,
    pagination: PaginationParam,
    sort?: (SortParam<CapexListSortField>|null),
  }
): CapexListReq {
  return {
    filter: input.filter,
    pagination: input.pagination,
    sort: input.sort === undefined ? null : input.sort,
  };
}

const CapexListReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"filter","default":{"kind":"nothing"},"name":"filter","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"CapexListFilter"}},"parameters":[]}},{"annotations":[],"serializedName":"pagination","default":{"kind":"nothing"},"name":"pagination","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"PaginationParam"}},"parameters":[]}},{"annotations":[],"serializedName":"sort","default":{"kind":"just","value":null},"name":"sort","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"SortParam"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"CapexListSortField"}},"parameters":[]}]}]}}]}},"name":"CapexListReq","version":{"kind":"nothing"}}};

export const snCapexListReq: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"CapexListReq"};

export function texprCapexListReq(): ADL.ATypeExpr<CapexListReq> {
  return {value : {typeRef : {kind: "reference", value : snCapexListReq}, parameters : []}};
}

export interface CapexListItem {
  expenseId: ferovinum_app_db.ExpenseId;
  reference: common_strings.StringNE;
  date: common.LocalDate;
  organisationId: ferovinum_app_db.OrganisationId;
  organisationName: common_strings.StringNE;
  expenseType: ferovinum_app_db.ExpenseTypeCode;
  amount: common.BigDecimal;
  currency: ferovinum_app_db.Currency;
  vendor: (common_strings.StringNE|null);
}

export function makeCapexListItem(
  input: {
    expenseId: ferovinum_app_db.ExpenseId,
    reference: common_strings.StringNE,
    date: common.LocalDate,
    organisationId: ferovinum_app_db.OrganisationId,
    organisationName: common_strings.StringNE,
    expenseType: ferovinum_app_db.ExpenseTypeCode,
    amount: common.BigDecimal,
    currency: ferovinum_app_db.Currency,
    vendor?: (common_strings.StringNE|null),
  }
): CapexListItem {
  return {
    expenseId: input.expenseId,
    reference: input.reference,
    date: input.date,
    organisationId: input.organisationId,
    organisationName: input.organisationName,
    expenseType: input.expenseType,
    amount: input.amount,
    currency: input.currency,
    vendor: input.vendor === undefined ? null : input.vendor,
  };
}

const CapexListItem_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"expenseId","default":{"kind":"nothing"},"name":"expenseId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseId"}},"parameters":[]}},{"annotations":[],"serializedName":"reference","default":{"kind":"nothing"},"name":"reference","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"date","default":{"kind":"nothing"},"name":"date","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"organisationName","default":{"kind":"nothing"},"name":"organisationName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseType","default":{"kind":"nothing"},"name":"expenseType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseTypeCode"}},"parameters":[]}},{"annotations":[],"serializedName":"amount","default":{"kind":"nothing"},"name":"amount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Currency"}},"parameters":[]}},{"annotations":[],"serializedName":"vendor","default":{"kind":"just","value":null},"name":"vendor","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"CapexListItem","version":{"kind":"nothing"}}};

export const snCapexListItem: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"CapexListItem"};

export function texprCapexListItem(): ADL.ATypeExpr<CapexListItem> {
  return {value : {typeRef : {kind: "reference", value : snCapexListItem}, parameters : []}};
}

export type RechargePaymentStatus = 'AwaitingPayment' | 'PaymentReceived' | 'Cancelled';
export const valuesRechargePaymentStatus : RechargePaymentStatus[] = ['AwaitingPayment', 'PaymentReceived', 'Cancelled'];

const RechargePaymentStatus_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"AwaitingPayment","default":{"kind":"nothing"},"name":"AwaitingPayment","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"PaymentReceived","default":{"kind":"nothing"},"name":"PaymentReceived","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Cancelled","default":{"kind":"nothing"},"name":"Cancelled","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"RechargePaymentStatus","version":{"kind":"nothing"}}};

export const snRechargePaymentStatus: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"RechargePaymentStatus"};

export function texprRechargePaymentStatus(): ADL.ATypeExpr<RechargePaymentStatus> {
  return {value : {typeRef : {kind: "reference", value : snRechargePaymentStatus}, parameters : []}};
}

export interface RechargeStatusEvent {
  status: RechargePaymentStatus;
  effectiveDate: common.LocalDate;
}

export function makeRechargeStatusEvent(
  input: {
    status: RechargePaymentStatus,
    effectiveDate: common.LocalDate,
  }
): RechargeStatusEvent {
  return {
    status: input.status,
    effectiveDate: input.effectiveDate,
  };
}

const RechargeStatusEvent_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"RechargePaymentStatus"}},"parameters":[]}},{"annotations":[],"serializedName":"effectiveDate","default":{"kind":"nothing"},"name":"effectiveDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}}]}},"name":"RechargeStatusEvent","version":{"kind":"nothing"}}};

export const snRechargeStatusEvent: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"RechargeStatusEvent"};

export function texprRechargeStatusEvent(): ADL.ATypeExpr<RechargeStatusEvent> {
  return {value : {typeRef : {kind: "reference", value : snRechargeStatusEvent}, parameters : []}};
}

/**
 * A document attached to an expense or recharge invoice
 */
export interface ExpenseDocument {
  storedFileId: ferovinum_app_db.StoredFileId;
  fileName: common_strings.StringNE;
  fileType: common_strings.StringNE;
  mimeType: common_strings.StringNE;
  uploadedBy: (ferovinum_app_db.AppUserId|null);
  documentType: (ferovinum_app_db.AttachedDocumentType|null);
}

export function makeExpenseDocument(
  input: {
    storedFileId: ferovinum_app_db.StoredFileId,
    fileName: common_strings.StringNE,
    fileType: common_strings.StringNE,
    mimeType: common_strings.StringNE,
    uploadedBy: (ferovinum_app_db.AppUserId|null),
    documentType: (ferovinum_app_db.AttachedDocumentType|null),
  }
): ExpenseDocument {
  return {
    storedFileId: input.storedFileId,
    fileName: input.fileName,
    fileType: input.fileType,
    mimeType: input.mimeType,
    uploadedBy: input.uploadedBy,
    documentType: input.documentType,
  };
}

const ExpenseDocument_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[{"value":"A document attached to an expense or recharge invoice\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"storedFileId","default":{"kind":"nothing"},"name":"storedFileId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StoredFileId"}},"parameters":[]}},{"annotations":[],"serializedName":"fileName","default":{"kind":"nothing"},"name":"fileName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"fileType","default":{"kind":"nothing"},"name":"fileType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"mimeType","default":{"kind":"nothing"},"name":"mimeType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"uploadedBy","default":{"kind":"nothing"},"name":"uploadedBy","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"AppUserId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"documentType","default":{"kind":"nothing"},"name":"documentType","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"AttachedDocumentType"}},"parameters":[]}]}}]}},"name":"ExpenseDocument","version":{"kind":"nothing"}}};

export const snExpenseDocument: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"ExpenseDocument"};

export function texprExpenseDocument(): ADL.ATypeExpr<ExpenseDocument> {
  return {value : {typeRef : {kind: "reference", value : snExpenseDocument}, parameters : []}};
}

export interface RechargeSummaryEntry {
  expenseId: ferovinum_app_db.ExpenseId;
  code: common_strings.StringNE;
  description: common_strings.StringNE;
  quantity: common.BigDecimal;
  amount: common.BigDecimal;
  salesTaxPc: (common.BigDecimal|null);
  vendor: (common_strings.StringNE|null);
  vendorReference: (common_strings.StringNE|null);
  documents: ExpenseDocument[];
}

export function makeRechargeSummaryEntry(
  input: {
    expenseId: ferovinum_app_db.ExpenseId,
    code: common_strings.StringNE,
    description: common_strings.StringNE,
    quantity: common.BigDecimal,
    amount: common.BigDecimal,
    salesTaxPc: (common.BigDecimal|null),
    vendor: (common_strings.StringNE|null),
    vendorReference: (common_strings.StringNE|null),
    documents: ExpenseDocument[],
  }
): RechargeSummaryEntry {
  return {
    expenseId: input.expenseId,
    code: input.code,
    description: input.description,
    quantity: input.quantity,
    amount: input.amount,
    salesTaxPc: input.salesTaxPc,
    vendor: input.vendor,
    vendorReference: input.vendorReference,
    documents: input.documents,
  };
}

const RechargeSummaryEntry_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"expenseId","default":{"kind":"nothing"},"name":"expenseId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseId"}},"parameters":[]}},{"annotations":[],"serializedName":"code","default":{"kind":"nothing"},"name":"code","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"quantity","default":{"kind":"nothing"},"name":"quantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"amount","default":{"kind":"nothing"},"name":"amount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"salesTaxPc","default":{"kind":"nothing"},"name":"salesTaxPc","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}},{"annotations":[],"serializedName":"vendor","default":{"kind":"nothing"},"name":"vendor","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"vendorReference","default":{"kind":"nothing"},"name":"vendorReference","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"documents","default":{"kind":"nothing"},"name":"documents","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"ExpenseDocument"}},"parameters":[]}]}}]}},"name":"RechargeSummaryEntry","version":{"kind":"nothing"}}};

export const snRechargeSummaryEntry: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"RechargeSummaryEntry"};

export function texprRechargeSummaryEntry(): ADL.ATypeExpr<RechargeSummaryEntry> {
  return {value : {typeRef : {kind: "reference", value : snRechargeSummaryEntry}, parameters : []}};
}

export interface RechargeSummaryResp {
  invoiceId: ferovinum_app_db.InvoiceId;
  reference: common_strings.StringNE;
  status: RechargePaymentStatus;
  statusChangedDate: (common.LocalDate|null);
  dateCreated: common.LocalDate;
  organisationId: ferovinum_app_db.OrganisationId;
  organisationName: common_strings.StringNE;
  entries: RechargeSummaryEntry[];
  invoiceDocument: (ExpenseDocument|null);
  subtotal: common.BigDecimal;
  salesTax: (common.BigDecimal|null);
  total: common.BigDecimal;
  currency: ferovinum_app_db.Currency;
}

export function makeRechargeSummaryResp(
  input: {
    invoiceId: ferovinum_app_db.InvoiceId,
    reference: common_strings.StringNE,
    status: RechargePaymentStatus,
    statusChangedDate: (common.LocalDate|null),
    dateCreated: common.LocalDate,
    organisationId: ferovinum_app_db.OrganisationId,
    organisationName: common_strings.StringNE,
    entries: RechargeSummaryEntry[],
    invoiceDocument: (ExpenseDocument|null),
    subtotal: common.BigDecimal,
    salesTax: (common.BigDecimal|null),
    total: common.BigDecimal,
    currency: ferovinum_app_db.Currency,
  }
): RechargeSummaryResp {
  return {
    invoiceId: input.invoiceId,
    reference: input.reference,
    status: input.status,
    statusChangedDate: input.statusChangedDate,
    dateCreated: input.dateCreated,
    organisationId: input.organisationId,
    organisationName: input.organisationName,
    entries: input.entries,
    invoiceDocument: input.invoiceDocument,
    subtotal: input.subtotal,
    salesTax: input.salesTax,
    total: input.total,
    currency: input.currency,
  };
}

const RechargeSummaryResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"invoiceId","default":{"kind":"nothing"},"name":"invoiceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"InvoiceId"}},"parameters":[]}},{"annotations":[],"serializedName":"reference","default":{"kind":"nothing"},"name":"reference","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"RechargePaymentStatus"}},"parameters":[]}},{"annotations":[],"serializedName":"statusChangedDate","default":{"kind":"nothing"},"name":"statusChangedDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"dateCreated","default":{"kind":"nothing"},"name":"dateCreated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"organisationName","default":{"kind":"nothing"},"name":"organisationName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"entries","default":{"kind":"nothing"},"name":"entries","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"RechargeSummaryEntry"}},"parameters":[]}]}},{"annotations":[],"serializedName":"invoiceDocument","default":{"kind":"nothing"},"name":"invoiceDocument","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"ExpenseDocument"}},"parameters":[]}]}},{"annotations":[],"serializedName":"subtotal","default":{"kind":"nothing"},"name":"subtotal","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"salesTax","default":{"kind":"nothing"},"name":"salesTax","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}},{"annotations":[],"serializedName":"total","default":{"kind":"nothing"},"name":"total","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Currency"}},"parameters":[]}}]}},"name":"RechargeSummaryResp","version":{"kind":"nothing"}}};

export const snRechargeSummaryResp: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"RechargeSummaryResp"};

export function texprRechargeSummaryResp(): ADL.ATypeExpr<RechargeSummaryResp> {
  return {value : {typeRef : {kind: "reference", value : snRechargeSummaryResp}, parameters : []}};
}

export type RechargeListSortField = 'Reference' | 'Date' | 'Organisation' | 'InvoiceAmount' | 'Status';
export const valuesRechargeListSortField : RechargeListSortField[] = ['Reference', 'Date', 'Organisation', 'InvoiceAmount', 'Status'];

const RechargeListSortField_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"Reference","default":{"kind":"nothing"},"name":"Reference","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Date","default":{"kind":"nothing"},"name":"Date","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Organisation","default":{"kind":"nothing"},"name":"Organisation","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"InvoiceAmount","default":{"kind":"nothing"},"name":"InvoiceAmount","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Status","default":{"kind":"nothing"},"name":"Status","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"RechargeListSortField","version":{"kind":"nothing"}}};

export const snRechargeListSortField: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"RechargeListSortField"};

export function texprRechargeListSortField(): ADL.ATypeExpr<RechargeListSortField> {
  return {value : {typeRef : {kind: "reference", value : snRechargeListSortField}, parameters : []}};
}

export type RechargeListTab = 'Outstanding' | 'Paid' | 'All';
export const valuesRechargeListTab : RechargeListTab[] = ['Outstanding', 'Paid', 'All'];

const RechargeListTab_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"Outstanding","default":{"kind":"nothing"},"name":"Outstanding","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Paid","default":{"kind":"nothing"},"name":"Paid","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"All","default":{"kind":"nothing"},"name":"All","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"RechargeListTab","version":{"kind":"nothing"}}};

export const snRechargeListTab: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"RechargeListTab"};

export function texprRechargeListTab(): ADL.ATypeExpr<RechargeListTab> {
  return {value : {typeRef : {kind: "reference", value : snRechargeListTab}, parameters : []}};
}

export interface RechargeListFilter {
  organisationId: (ferovinum_app_db.OrganisationId|null);
  expenseTypes: ferovinum_app_db.ExpenseTypeCode[];
  tab: RechargeListTab;
  search: (common_strings.StringNE|null);
  fromDate: (common.LocalDate|null);
  toDate: (common.LocalDate|null);
  vendors: common_strings.StringNE[];
}

export function makeRechargeListFilter(
  input: {
    organisationId?: (ferovinum_app_db.OrganisationId|null),
    expenseTypes?: ferovinum_app_db.ExpenseTypeCode[],
    tab?: RechargeListTab,
    search?: (common_strings.StringNE|null),
    fromDate?: (common.LocalDate|null),
    toDate?: (common.LocalDate|null),
    vendors?: common_strings.StringNE[],
  }
): RechargeListFilter {
  return {
    organisationId: input.organisationId === undefined ? null : input.organisationId,
    expenseTypes: input.expenseTypes === undefined ? [] : input.expenseTypes,
    tab: input.tab === undefined ? "All" : input.tab,
    search: input.search === undefined ? null : input.search,
    fromDate: input.fromDate === undefined ? null : input.fromDate,
    toDate: input.toDate === undefined ? null : input.toDate,
    vendors: input.vendors === undefined ? [] : input.vendors,
  };
}

const RechargeListFilter_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"organisationId","default":{"kind":"just","value":null},"name":"organisationId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"expenseTypes","default":{"kind":"just","value":[]},"name":"expenseTypes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseTypeCode"}},"parameters":[]}]}},{"annotations":[],"serializedName":"tab","default":{"kind":"just","value":"All"},"name":"tab","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"RechargeListTab"}},"parameters":[]}},{"annotations":[],"serializedName":"search","default":{"kind":"just","value":null},"name":"search","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"fromDate","default":{"kind":"just","value":null},"name":"fromDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"toDate","default":{"kind":"just","value":null},"name":"toDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"vendors","default":{"kind":"just","value":[]},"name":"vendors","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"RechargeListFilter","version":{"kind":"nothing"}}};

export const snRechargeListFilter: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"RechargeListFilter"};

export function texprRechargeListFilter(): ADL.ATypeExpr<RechargeListFilter> {
  return {value : {typeRef : {kind: "reference", value : snRechargeListFilter}, parameters : []}};
}

export interface RechargeListReq {
  filter: RechargeListFilter;
  pagination: PaginationParam;
  sort: (SortParam<RechargeListSortField>|null);
}

export function makeRechargeListReq(
  input: {
    filter: RechargeListFilter,
    pagination: PaginationParam,
    sort?: (SortParam<RechargeListSortField>|null),
  }
): RechargeListReq {
  return {
    filter: input.filter,
    pagination: input.pagination,
    sort: input.sort === undefined ? null : input.sort,
  };
}

const RechargeListReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"filter","default":{"kind":"nothing"},"name":"filter","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"RechargeListFilter"}},"parameters":[]}},{"annotations":[],"serializedName":"pagination","default":{"kind":"nothing"},"name":"pagination","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"PaginationParam"}},"parameters":[]}},{"annotations":[],"serializedName":"sort","default":{"kind":"just","value":null},"name":"sort","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"SortParam"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"RechargeListSortField"}},"parameters":[]}]}]}}]}},"name":"RechargeListReq","version":{"kind":"nothing"}}};

export const snRechargeListReq: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"RechargeListReq"};

export function texprRechargeListReq(): ADL.ATypeExpr<RechargeListReq> {
  return {value : {typeRef : {kind: "reference", value : snRechargeListReq}, parameters : []}};
}

export interface RechargeListItem {
  invoiceId: ferovinum_app_db.InvoiceId;
  reference: common_strings.StringNE;
  date: common.LocalDate;
  dueDate: common.LocalDate;
  organisationId: ferovinum_app_db.OrganisationId;
  organisationName: common_strings.StringNE;
  expenseTypes: ferovinum_app_db.ExpenseTypeCode[];
  vendors: common_strings.StringNE[];
  invoiceAmount: common.BigDecimal;
  currency: ferovinum_app_db.Currency;
  status: RechargePaymentStatus;
}

export function makeRechargeListItem(
  input: {
    invoiceId: ferovinum_app_db.InvoiceId,
    reference: common_strings.StringNE,
    date: common.LocalDate,
    dueDate: common.LocalDate,
    organisationId: ferovinum_app_db.OrganisationId,
    organisationName: common_strings.StringNE,
    expenseTypes: ferovinum_app_db.ExpenseTypeCode[],
    vendors: common_strings.StringNE[],
    invoiceAmount: common.BigDecimal,
    currency: ferovinum_app_db.Currency,
    status: RechargePaymentStatus,
  }
): RechargeListItem {
  return {
    invoiceId: input.invoiceId,
    reference: input.reference,
    date: input.date,
    dueDate: input.dueDate,
    organisationId: input.organisationId,
    organisationName: input.organisationName,
    expenseTypes: input.expenseTypes,
    vendors: input.vendors,
    invoiceAmount: input.invoiceAmount,
    currency: input.currency,
    status: input.status,
  };
}

const RechargeListItem_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"invoiceId","default":{"kind":"nothing"},"name":"invoiceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"InvoiceId"}},"parameters":[]}},{"annotations":[],"serializedName":"reference","default":{"kind":"nothing"},"name":"reference","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"date","default":{"kind":"nothing"},"name":"date","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"dueDate","default":{"kind":"nothing"},"name":"dueDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"organisationName","default":{"kind":"nothing"},"name":"organisationName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseTypes","default":{"kind":"nothing"},"name":"expenseTypes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseTypeCode"}},"parameters":[]}]}},{"annotations":[],"serializedName":"vendors","default":{"kind":"nothing"},"name":"vendors","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"invoiceAmount","default":{"kind":"nothing"},"name":"invoiceAmount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Currency"}},"parameters":[]}},{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"RechargePaymentStatus"}},"parameters":[]}}]}},"name":"RechargeListItem","version":{"kind":"nothing"}}};

export const snRechargeListItem: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"RechargeListItem"};

export function texprRechargeListItem(): ADL.ATypeExpr<RechargeListItem> {
  return {value : {typeRef : {kind: "reference", value : snRechargeListItem}, parameters : []}};
}

export interface RechargeBalanceSummaryItem {
  currency: ferovinum_app_db.Currency;
  totalOutstanding: common.BigDecimal;
  totalOverdue: common.BigDecimal;
}

export function makeRechargeBalanceSummaryItem(
  input: {
    currency: ferovinum_app_db.Currency,
    totalOutstanding: common.BigDecimal,
    totalOverdue: common.BigDecimal,
  }
): RechargeBalanceSummaryItem {
  return {
    currency: input.currency,
    totalOutstanding: input.totalOutstanding,
    totalOverdue: input.totalOverdue,
  };
}

const RechargeBalanceSummaryItem_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Currency"}},"parameters":[]}},{"annotations":[],"serializedName":"totalOutstanding","default":{"kind":"nothing"},"name":"totalOutstanding","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"totalOverdue","default":{"kind":"nothing"},"name":"totalOverdue","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"RechargeBalanceSummaryItem","version":{"kind":"nothing"}}};

export const snRechargeBalanceSummaryItem: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"RechargeBalanceSummaryItem"};

export function texprRechargeBalanceSummaryItem(): ADL.ATypeExpr<RechargeBalanceSummaryItem> {
  return {value : {typeRef : {kind: "reference", value : snRechargeBalanceSummaryItem}, parameters : []}};
}

export interface RechargeMarkPaidReq {
  invoiceId: ferovinum_app_db.InvoiceId;
  paymentDate: common.LocalDate;
}

export function makeRechargeMarkPaidReq(
  input: {
    invoiceId: ferovinum_app_db.InvoiceId,
    paymentDate: common.LocalDate,
  }
): RechargeMarkPaidReq {
  return {
    invoiceId: input.invoiceId,
    paymentDate: input.paymentDate,
  };
}

const RechargeMarkPaidReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"invoiceId","default":{"kind":"nothing"},"name":"invoiceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"InvoiceId"}},"parameters":[]}},{"annotations":[],"serializedName":"paymentDate","default":{"kind":"nothing"},"name":"paymentDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}}]}},"name":"RechargeMarkPaidReq","version":{"kind":"nothing"}}};

export const snRechargeMarkPaidReq: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"RechargeMarkPaidReq"};

export function texprRechargeMarkPaidReq(): ADL.ATypeExpr<RechargeMarkPaidReq> {
  return {value : {typeRef : {kind: "reference", value : snRechargeMarkPaidReq}, parameters : []}};
}

export interface RechargeCancelReq {
  invoiceId: ferovinum_app_db.InvoiceId;
  cancelDate: common.LocalDate;
}

export function makeRechargeCancelReq(
  input: {
    invoiceId: ferovinum_app_db.InvoiceId,
    cancelDate: common.LocalDate,
  }
): RechargeCancelReq {
  return {
    invoiceId: input.invoiceId,
    cancelDate: input.cancelDate,
  };
}

const RechargeCancelReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"invoiceId","default":{"kind":"nothing"},"name":"invoiceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"InvoiceId"}},"parameters":[]}},{"annotations":[],"serializedName":"cancelDate","default":{"kind":"nothing"},"name":"cancelDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}}]}},"name":"RechargeCancelReq","version":{"kind":"nothing"}}};

export const snRechargeCancelReq: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"RechargeCancelReq"};

export function texprRechargeCancelReq(): ADL.ATypeExpr<RechargeCancelReq> {
  return {value : {typeRef : {kind: "reference", value : snRechargeCancelReq}, parameters : []}};
}

export interface CapexSummaryOrigin {
  originType: ferovinum_app_db.ExpenseOriginType;
  purchaseRequestId: (ferovinum_app_db.PurchaseRequestId|null);
  productionOrderTaskRunId: (ferovinum_app_db.ProductionOrderTaskRunId|null);
  saleOrderId: (ferovinum_app_db.SaleOrderId|null);
}

export function makeCapexSummaryOrigin(
  input: {
    originType: ferovinum_app_db.ExpenseOriginType,
    purchaseRequestId?: (ferovinum_app_db.PurchaseRequestId|null),
    productionOrderTaskRunId?: (ferovinum_app_db.ProductionOrderTaskRunId|null),
    saleOrderId?: (ferovinum_app_db.SaleOrderId|null),
  }
): CapexSummaryOrigin {
  return {
    originType: input.originType,
    purchaseRequestId: input.purchaseRequestId === undefined ? null : input.purchaseRequestId,
    productionOrderTaskRunId: input.productionOrderTaskRunId === undefined ? null : input.productionOrderTaskRunId,
    saleOrderId: input.saleOrderId === undefined ? null : input.saleOrderId,
  };
}

const CapexSummaryOrigin_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"originType","default":{"kind":"nothing"},"name":"originType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseOriginType"}},"parameters":[]}},{"annotations":[],"serializedName":"purchaseRequestId","default":{"kind":"just","value":null},"name":"purchaseRequestId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PurchaseRequestId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"productionOrderTaskRunId","default":{"kind":"just","value":null},"name":"productionOrderTaskRunId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductionOrderTaskRunId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"saleOrderId","default":{"kind":"just","value":null},"name":"saleOrderId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"SaleOrderId"}},"parameters":[]}]}}]}},"name":"CapexSummaryOrigin","version":{"kind":"nothing"}}};

export const snCapexSummaryOrigin: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"CapexSummaryOrigin"};

export function texprCapexSummaryOrigin(): ADL.ATypeExpr<CapexSummaryOrigin> {
  return {value : {typeRef : {kind: "reference", value : snCapexSummaryOrigin}, parameters : []}};
}

export interface CapexSummaryDescription {
  descriptionId: ferovinum_app_db.CapitalisedExpenseDescriptionId;
  expenseType: ferovinum_app_db.CapitalisedExpenseType;
  expenseDescription: common_strings.StringNE;
  vendor: string;
  amountPaid: common.BigDecimal;
  currency: ferovinum_app_db.Currency;
  spreadType: ferovinum_app_db.CapitalisedExpenseSpreadType;
  application: ferovinum_app_db.CapitalisedExpenseApplication;
  referenceNumber: (common_strings.StringNE|null);
  valueAccretive: boolean;
  expenseDate: common.LocalDate;
}

export function makeCapexSummaryDescription(
  input: {
    descriptionId: ferovinum_app_db.CapitalisedExpenseDescriptionId,
    expenseType: ferovinum_app_db.CapitalisedExpenseType,
    expenseDescription: common_strings.StringNE,
    vendor: string,
    amountPaid: common.BigDecimal,
    currency: ferovinum_app_db.Currency,
    spreadType: ferovinum_app_db.CapitalisedExpenseSpreadType,
    application: ferovinum_app_db.CapitalisedExpenseApplication,
    referenceNumber: (common_strings.StringNE|null),
    valueAccretive: boolean,
    expenseDate: common.LocalDate,
  }
): CapexSummaryDescription {
  return {
    descriptionId: input.descriptionId,
    expenseType: input.expenseType,
    expenseDescription: input.expenseDescription,
    vendor: input.vendor,
    amountPaid: input.amountPaid,
    currency: input.currency,
    spreadType: input.spreadType,
    application: input.application,
    referenceNumber: input.referenceNumber,
    valueAccretive: input.valueAccretive,
    expenseDate: input.expenseDate,
  };
}

const CapexSummaryDescription_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"descriptionId","default":{"kind":"nothing"},"name":"descriptionId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"CapitalisedExpenseDescriptionId"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseType","default":{"kind":"nothing"},"name":"expenseType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"CapitalisedExpenseType"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseDescription","default":{"kind":"nothing"},"name":"expenseDescription","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"vendor","default":{"kind":"nothing"},"name":"vendor","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"amountPaid","default":{"kind":"nothing"},"name":"amountPaid","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Currency"}},"parameters":[]}},{"annotations":[],"serializedName":"spreadType","default":{"kind":"nothing"},"name":"spreadType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"CapitalisedExpenseSpreadType"}},"parameters":[]}},{"annotations":[],"serializedName":"application","default":{"kind":"nothing"},"name":"application","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"CapitalisedExpenseApplication"}},"parameters":[]}},{"annotations":[],"serializedName":"referenceNumber","default":{"kind":"nothing"},"name":"referenceNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"valueAccretive","default":{"kind":"nothing"},"name":"valueAccretive","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"expenseDate","default":{"kind":"nothing"},"name":"expenseDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}}]}},"name":"CapexSummaryDescription","version":{"kind":"nothing"}}};

export const snCapexSummaryDescription: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"CapexSummaryDescription"};

export function texprCapexSummaryDescription(): ADL.ATypeExpr<CapexSummaryDescription> {
  return {value : {typeRef : {kind: "reference", value : snCapexSummaryDescription}, parameters : []}};
}

export interface CapexSummaryStatusEvent {
  status: ferovinum_app_db.ExpenseStatus;
  transitionedAt: common.Instant;
  notes: string;
}

export function makeCapexSummaryStatusEvent(
  input: {
    status: ferovinum_app_db.ExpenseStatus,
    transitionedAt: common.Instant,
    notes: string,
  }
): CapexSummaryStatusEvent {
  return {
    status: input.status,
    transitionedAt: input.transitionedAt,
    notes: input.notes,
  };
}

const CapexSummaryStatusEvent_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseStatus"}},"parameters":[]}},{"annotations":[],"serializedName":"transitionedAt","default":{"kind":"nothing"},"name":"transitionedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"notes","default":{"kind":"nothing"},"name":"notes","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"CapexSummaryStatusEvent","version":{"kind":"nothing"}}};

export const snCapexSummaryStatusEvent: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"CapexSummaryStatusEvent"};

export function texprCapexSummaryStatusEvent(): ADL.ATypeExpr<CapexSummaryStatusEvent> {
  return {value : {typeRef : {kind: "reference", value : snCapexSummaryStatusEvent}, parameters : []}};
}

export interface CapexSummaryResp {
  /**
   * Expense core fields
   */
  expenseId: ferovinum_app_db.ExpenseId;
  reference: common_strings.StringNE;
  expenseDate: common.LocalDate;
  description: common_strings.StringNE;
  expenseTypeCode: ferovinum_app_db.ExpenseTypeCode;
  value: common.BigDecimal;
  currency: ferovinum_app_db.Currency;
  vendor: (common_strings.StringNE|null);
  vendorReference: (common_strings.StringNE|null);
  notes: (common_strings.StringMD|null);
  feroEntity: ferovinum_app_db.FeroEntity;
  organisationId: ferovinum_app_db.OrganisationId;
  organisationName: common_strings.StringNE;
  /**
   * Connected records
   */
  origin: CapexSummaryOrigin;
  capexDescription: CapexSummaryDescription;
  capexAllocationCount: number;
  statusEvents: CapexSummaryStatusEvent[];
  documents: ExpenseDocument[];
}

export function makeCapexSummaryResp(
  input: {
    expenseId: ferovinum_app_db.ExpenseId,
    reference: common_strings.StringNE,
    expenseDate: common.LocalDate,
    description: common_strings.StringNE,
    expenseTypeCode: ferovinum_app_db.ExpenseTypeCode,
    value: common.BigDecimal,
    currency: ferovinum_app_db.Currency,
    vendor: (common_strings.StringNE|null),
    vendorReference: (common_strings.StringNE|null),
    notes: (common_strings.StringMD|null),
    feroEntity: ferovinum_app_db.FeroEntity,
    organisationId: ferovinum_app_db.OrganisationId,
    organisationName: common_strings.StringNE,
    origin: CapexSummaryOrigin,
    capexDescription: CapexSummaryDescription,
    capexAllocationCount: number,
    statusEvents: CapexSummaryStatusEvent[],
    documents: ExpenseDocument[],
  }
): CapexSummaryResp {
  return {
    expenseId: input.expenseId,
    reference: input.reference,
    expenseDate: input.expenseDate,
    description: input.description,
    expenseTypeCode: input.expenseTypeCode,
    value: input.value,
    currency: input.currency,
    vendor: input.vendor,
    vendorReference: input.vendorReference,
    notes: input.notes,
    feroEntity: input.feroEntity,
    organisationId: input.organisationId,
    organisationName: input.organisationName,
    origin: input.origin,
    capexDescription: input.capexDescription,
    capexAllocationCount: input.capexAllocationCount,
    statusEvents: input.statusEvents,
    documents: input.documents,
  };
}

const CapexSummaryResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"Expense core fields\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"expenseId","default":{"kind":"nothing"},"name":"expenseId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseId"}},"parameters":[]}},{"annotations":[],"serializedName":"reference","default":{"kind":"nothing"},"name":"reference","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseDate","default":{"kind":"nothing"},"name":"expenseDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseTypeCode","default":{"kind":"nothing"},"name":"expenseTypeCode","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseTypeCode"}},"parameters":[]}},{"annotations":[],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Currency"}},"parameters":[]}},{"annotations":[],"serializedName":"vendor","default":{"kind":"nothing"},"name":"vendor","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"vendorReference","default":{"kind":"nothing"},"name":"vendorReference","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"notes","default":{"kind":"nothing"},"name":"notes","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringMD"}},"parameters":[]}]}},{"annotations":[],"serializedName":"feroEntity","default":{"kind":"nothing"},"name":"feroEntity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"FeroEntity"}},"parameters":[]}},{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"organisationName","default":{"kind":"nothing"},"name":"organisationName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"value":"Connected records\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"origin","default":{"kind":"nothing"},"name":"origin","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"CapexSummaryOrigin"}},"parameters":[]}},{"annotations":[],"serializedName":"capexDescription","default":{"kind":"nothing"},"name":"capexDescription","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"CapexSummaryDescription"}},"parameters":[]}},{"annotations":[],"serializedName":"capexAllocationCount","default":{"kind":"nothing"},"name":"capexAllocationCount","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"statusEvents","default":{"kind":"nothing"},"name":"statusEvents","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"CapexSummaryStatusEvent"}},"parameters":[]}]}},{"annotations":[],"serializedName":"documents","default":{"kind":"nothing"},"name":"documents","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"ExpenseDocument"}},"parameters":[]}]}}]}},"name":"CapexSummaryResp","version":{"kind":"nothing"}}};

export const snCapexSummaryResp: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"CapexSummaryResp"};

export function texprCapexSummaryResp(): ADL.ATypeExpr<CapexSummaryResp> {
  return {value : {typeRef : {kind: "reference", value : snCapexSummaryResp}, parameters : []}};
}

export type ExpenseListSettlementMethod = 'Recharge' | 'Capitalised' | 'PurchaseRequest';
export const valuesExpenseListSettlementMethod : ExpenseListSettlementMethod[] = ['Recharge', 'Capitalised', 'PurchaseRequest'];

const ExpenseListSettlementMethod_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[{"value":"Settlement method for filtering and display on the unified expenses list.\nDistinct from db.ExpenseSettlementMethod which uses raw DB values (RECHARGE/FUNDED/PURCHASE_REQUEST).\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"Recharge","default":{"kind":"nothing"},"name":"Recharge","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Capitalised","default":{"kind":"nothing"},"name":"Capitalised","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"PurchaseRequest","default":{"kind":"nothing"},"name":"PurchaseRequest","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"ExpenseListSettlementMethod","version":{"kind":"nothing"}}};

export const snExpenseListSettlementMethod: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"ExpenseListSettlementMethod"};

export function texprExpenseListSettlementMethod(): ADL.ATypeExpr<ExpenseListSettlementMethod> {
  return {value : {typeRef : {kind: "reference", value : snExpenseListSettlementMethod}, parameters : []}};
}

export type ExpenseListSortField = 'Reference' | 'Date' | 'Organisation' | 'Type' | 'Amount' | 'SettlementMethod' | 'Vendor';
export const valuesExpenseListSortField : ExpenseListSortField[] = ['Reference', 'Date', 'Organisation', 'Type', 'Amount', 'SettlementMethod', 'Vendor'];

const ExpenseListSortField_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"Reference","default":{"kind":"nothing"},"name":"Reference","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Date","default":{"kind":"nothing"},"name":"Date","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Organisation","default":{"kind":"nothing"},"name":"Organisation","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Type","default":{"kind":"nothing"},"name":"Type","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Amount","default":{"kind":"nothing"},"name":"Amount","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"SettlementMethod","default":{"kind":"nothing"},"name":"SettlementMethod","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Vendor","default":{"kind":"nothing"},"name":"Vendor","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"ExpenseListSortField","version":{"kind":"nothing"}}};

export const snExpenseListSortField: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"ExpenseListSortField"};

export function texprExpenseListSortField(): ADL.ATypeExpr<ExpenseListSortField> {
  return {value : {typeRef : {kind: "reference", value : snExpenseListSortField}, parameters : []}};
}

export interface ExpenseListFilter {
  organisationId: (ferovinum_app_db.OrganisationId|null);
  expenseTypes: ferovinum_app_db.ExpenseTypeCode[];
  settlementMethods: ExpenseListSettlementMethod[];
  search: (common_strings.StringNE|null);
  fromDate: (common.LocalDate|null);
  toDate: (common.LocalDate|null);
  vendors: common_strings.StringNE[];
  statuses: ferovinum_app_db.ExpenseStatus[];
}

export function makeExpenseListFilter(
  input: {
    organisationId?: (ferovinum_app_db.OrganisationId|null),
    expenseTypes?: ferovinum_app_db.ExpenseTypeCode[],
    settlementMethods?: ExpenseListSettlementMethod[],
    search?: (common_strings.StringNE|null),
    fromDate?: (common.LocalDate|null),
    toDate?: (common.LocalDate|null),
    vendors?: common_strings.StringNE[],
    statuses?: ferovinum_app_db.ExpenseStatus[],
  }
): ExpenseListFilter {
  return {
    organisationId: input.organisationId === undefined ? null : input.organisationId,
    expenseTypes: input.expenseTypes === undefined ? [] : input.expenseTypes,
    settlementMethods: input.settlementMethods === undefined ? [] : input.settlementMethods,
    search: input.search === undefined ? null : input.search,
    fromDate: input.fromDate === undefined ? null : input.fromDate,
    toDate: input.toDate === undefined ? null : input.toDate,
    vendors: input.vendors === undefined ? [] : input.vendors,
    statuses: input.statuses === undefined ? [] : input.statuses,
  };
}

const ExpenseListFilter_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"organisationId","default":{"kind":"just","value":null},"name":"organisationId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"expenseTypes","default":{"kind":"just","value":[]},"name":"expenseTypes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseTypeCode"}},"parameters":[]}]}},{"annotations":[],"serializedName":"settlementMethods","default":{"kind":"just","value":[]},"name":"settlementMethods","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"ExpenseListSettlementMethod"}},"parameters":[]}]}},{"annotations":[],"serializedName":"search","default":{"kind":"just","value":null},"name":"search","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"fromDate","default":{"kind":"just","value":null},"name":"fromDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"toDate","default":{"kind":"just","value":null},"name":"toDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"vendors","default":{"kind":"just","value":[]},"name":"vendors","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"statuses","default":{"kind":"just","value":[]},"name":"statuses","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseStatus"}},"parameters":[]}]}}]}},"name":"ExpenseListFilter","version":{"kind":"nothing"}}};

export const snExpenseListFilter: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"ExpenseListFilter"};

export function texprExpenseListFilter(): ADL.ATypeExpr<ExpenseListFilter> {
  return {value : {typeRef : {kind: "reference", value : snExpenseListFilter}, parameters : []}};
}

export interface ExpenseListReq {
  filter: ExpenseListFilter;
  pagination: PaginationParam;
  sort: (SortParam<ExpenseListSortField>|null);
}

export function makeExpenseListReq(
  input: {
    filter: ExpenseListFilter,
    pagination: PaginationParam,
    sort?: (SortParam<ExpenseListSortField>|null),
  }
): ExpenseListReq {
  return {
    filter: input.filter,
    pagination: input.pagination,
    sort: input.sort === undefined ? null : input.sort,
  };
}

const ExpenseListReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"filter","default":{"kind":"nothing"},"name":"filter","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"ExpenseListFilter"}},"parameters":[]}},{"annotations":[],"serializedName":"pagination","default":{"kind":"nothing"},"name":"pagination","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"PaginationParam"}},"parameters":[]}},{"annotations":[],"serializedName":"sort","default":{"kind":"just","value":null},"name":"sort","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"SortParam"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"ExpenseListSortField"}},"parameters":[]}]}]}}]}},"name":"ExpenseListReq","version":{"kind":"nothing"}}};

export const snExpenseListReq: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"ExpenseListReq"};

export function texprExpenseListReq(): ADL.ATypeExpr<ExpenseListReq> {
  return {value : {typeRef : {kind: "reference", value : snExpenseListReq}, parameters : []}};
}

export interface ExpenseRelatesTo_RechargeInvoice {
  kind: 'rechargeInvoice';
  value: ferovinum_app_db.InvoiceId;
}
export interface ExpenseRelatesTo_CapitalisedExpense {
  kind: 'capitalisedExpense';
  value: ferovinum_app_db.ExpenseId;
}
export interface ExpenseRelatesTo_SaleOrder {
  kind: 'saleOrder';
  value: ferovinum_app_db.SaleOrderId;
}
export interface ExpenseRelatesTo_PurchaseRequest {
  kind: 'purchaseRequest';
  value: ferovinum_app_db.PurchaseRequestId;
}
export interface ExpenseRelatesTo_ProductionOrder {
  kind: 'productionOrder';
  value: ferovinum_app_db.ProductionOrderId;
}

/**
 * What an expense relates to — determines the link target in the UI
 */
export type ExpenseRelatesTo = ExpenseRelatesTo_RechargeInvoice | ExpenseRelatesTo_CapitalisedExpense | ExpenseRelatesTo_SaleOrder | ExpenseRelatesTo_PurchaseRequest | ExpenseRelatesTo_ProductionOrder;

export interface ExpenseRelatesToOpts {
  rechargeInvoice: ferovinum_app_db.InvoiceId;
  capitalisedExpense: ferovinum_app_db.ExpenseId;
  saleOrder: ferovinum_app_db.SaleOrderId;
  purchaseRequest: ferovinum_app_db.PurchaseRequestId;
  productionOrder: ferovinum_app_db.ProductionOrderId;
}

export function makeExpenseRelatesTo<K extends keyof ExpenseRelatesToOpts>(kind: K, value: ExpenseRelatesToOpts[K]) { return {kind, value}; }

const ExpenseRelatesTo_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[{"value":"What an expense relates to — determines the link target in the UI\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"rechargeInvoice","default":{"kind":"nothing"},"name":"rechargeInvoice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"InvoiceId"}},"parameters":[]}},{"annotations":[],"serializedName":"capitalisedExpense","default":{"kind":"nothing"},"name":"capitalisedExpense","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseId"}},"parameters":[]}},{"annotations":[],"serializedName":"saleOrder","default":{"kind":"nothing"},"name":"saleOrder","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"SaleOrderId"}},"parameters":[]}},{"annotations":[],"serializedName":"purchaseRequest","default":{"kind":"nothing"},"name":"purchaseRequest","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PurchaseRequestId"}},"parameters":[]}},{"annotations":[],"serializedName":"productionOrder","default":{"kind":"nothing"},"name":"productionOrder","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductionOrderId"}},"parameters":[]}}]}},"name":"ExpenseRelatesTo","version":{"kind":"nothing"}}};

export const snExpenseRelatesTo: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"ExpenseRelatesTo"};

export function texprExpenseRelatesTo(): ADL.ATypeExpr<ExpenseRelatesTo> {
  return {value : {typeRef : {kind: "reference", value : snExpenseRelatesTo}, parameters : []}};
}

export interface ExpenseListItem {
  expenseId: ferovinum_app_db.ExpenseId;
  reference: common_strings.StringNE;
  date: common.LocalDate;
  organisationId: ferovinum_app_db.OrganisationId;
  organisationName: common_strings.StringNE;
  expenseType: ferovinum_app_db.ExpenseTypeCode;
  settlementMethod: ExpenseListSettlementMethod;
  vendor: (common_strings.StringNE|null);
  currency: ferovinum_app_db.Currency;
  valueExVat: common.BigDecimal;
  vatAmount: (common.BigDecimal|null);
  relatesTo: (ExpenseRelatesTo|null);
  relatesToReference: (common_strings.StringNE|null);
}

export function makeExpenseListItem(
  input: {
    expenseId: ferovinum_app_db.ExpenseId,
    reference: common_strings.StringNE,
    date: common.LocalDate,
    organisationId: ferovinum_app_db.OrganisationId,
    organisationName: common_strings.StringNE,
    expenseType: ferovinum_app_db.ExpenseTypeCode,
    settlementMethod: ExpenseListSettlementMethod,
    vendor?: (common_strings.StringNE|null),
    currency: ferovinum_app_db.Currency,
    valueExVat: common.BigDecimal,
    vatAmount?: (common.BigDecimal|null),
    relatesTo?: (ExpenseRelatesTo|null),
    relatesToReference?: (common_strings.StringNE|null),
  }
): ExpenseListItem {
  return {
    expenseId: input.expenseId,
    reference: input.reference,
    date: input.date,
    organisationId: input.organisationId,
    organisationName: input.organisationName,
    expenseType: input.expenseType,
    settlementMethod: input.settlementMethod,
    vendor: input.vendor === undefined ? null : input.vendor,
    currency: input.currency,
    valueExVat: input.valueExVat,
    vatAmount: input.vatAmount === undefined ? null : input.vatAmount,
    relatesTo: input.relatesTo === undefined ? null : input.relatesTo,
    relatesToReference: input.relatesToReference === undefined ? null : input.relatesToReference,
  };
}

const ExpenseListItem_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"expenseId","default":{"kind":"nothing"},"name":"expenseId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseId"}},"parameters":[]}},{"annotations":[],"serializedName":"reference","default":{"kind":"nothing"},"name":"reference","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"date","default":{"kind":"nothing"},"name":"date","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"organisationName","default":{"kind":"nothing"},"name":"organisationName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseType","default":{"kind":"nothing"},"name":"expenseType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseTypeCode"}},"parameters":[]}},{"annotations":[],"serializedName":"settlementMethod","default":{"kind":"nothing"},"name":"settlementMethod","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"ExpenseListSettlementMethod"}},"parameters":[]}},{"annotations":[],"serializedName":"vendor","default":{"kind":"just","value":null},"name":"vendor","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Currency"}},"parameters":[]}},{"annotations":[],"serializedName":"valueExVat","default":{"kind":"nothing"},"name":"valueExVat","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"vatAmount","default":{"kind":"just","value":null},"name":"vatAmount","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}},{"annotations":[],"serializedName":"relatesTo","default":{"kind":"just","value":null},"name":"relatesTo","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"ExpenseRelatesTo"}},"parameters":[]}]}},{"annotations":[],"serializedName":"relatesToReference","default":{"kind":"just","value":null},"name":"relatesToReference","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"ExpenseListItem","version":{"kind":"nothing"}}};

export const snExpenseListItem: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"ExpenseListItem"};

export function texprExpenseListItem(): ADL.ATypeExpr<ExpenseListItem> {
  return {value : {typeRef : {kind: "reference", value : snExpenseListItem}, parameters : []}};
}

export interface ExpenseCsvReportReq {
  organisationId: (ferovinum_app_db.OrganisationId|null);
  expenseTypes: ferovinum_app_db.ExpenseTypeCode[];
  settlementMethods: ExpenseListSettlementMethod[];
  search: (common_strings.StringNE|null);
  fromDate: (common.LocalDate|null);
  toDate: (common.LocalDate|null);
  vendors: common_strings.StringNE[];
  statuses: ferovinum_app_db.ExpenseStatus[];
}

export function makeExpenseCsvReportReq(
  input: {
    organisationId?: (ferovinum_app_db.OrganisationId|null),
    expenseTypes?: ferovinum_app_db.ExpenseTypeCode[],
    settlementMethods?: ExpenseListSettlementMethod[],
    search?: (common_strings.StringNE|null),
    fromDate?: (common.LocalDate|null),
    toDate?: (common.LocalDate|null),
    vendors?: common_strings.StringNE[],
    statuses?: ferovinum_app_db.ExpenseStatus[],
  }
): ExpenseCsvReportReq {
  return {
    organisationId: input.organisationId === undefined ? null : input.organisationId,
    expenseTypes: input.expenseTypes === undefined ? [] : input.expenseTypes,
    settlementMethods: input.settlementMethods === undefined ? [] : input.settlementMethods,
    search: input.search === undefined ? null : input.search,
    fromDate: input.fromDate === undefined ? null : input.fromDate,
    toDate: input.toDate === undefined ? null : input.toDate,
    vendors: input.vendors === undefined ? [] : input.vendors,
    statuses: input.statuses === undefined ? [] : input.statuses,
  };
}

const ExpenseCsvReportReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"organisationId","default":{"kind":"just","value":null},"name":"organisationId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"expenseTypes","default":{"kind":"just","value":[]},"name":"expenseTypes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseTypeCode"}},"parameters":[]}]}},{"annotations":[],"serializedName":"settlementMethods","default":{"kind":"just","value":[]},"name":"settlementMethods","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"ExpenseListSettlementMethod"}},"parameters":[]}]}},{"annotations":[],"serializedName":"search","default":{"kind":"just","value":null},"name":"search","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"fromDate","default":{"kind":"just","value":null},"name":"fromDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"toDate","default":{"kind":"just","value":null},"name":"toDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"vendors","default":{"kind":"just","value":[]},"name":"vendors","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"statuses","default":{"kind":"just","value":[]},"name":"statuses","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseStatus"}},"parameters":[]}]}}]}},"name":"ExpenseCsvReportReq","version":{"kind":"nothing"}}};

export const snExpenseCsvReportReq: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"ExpenseCsvReportReq"};

export function texprExpenseCsvReportReq(): ADL.ATypeExpr<ExpenseCsvReportReq> {
  return {value : {typeRef : {kind: "reference", value : snExpenseCsvReportReq}, parameters : []}};
}

/**
 * Request to calculate VAT rates for expense type codes
 */
export interface CalculateExpenseTaxReq {
  feroEntity: ferovinum_app_db.FeroEntity;
  organisationId: ferovinum_app_db.OrganisationId;
  calculationDate: common.LocalDate;
  expenseTypeCodes: ferovinum_app_db.ExpenseTypeCode[];
}

export function makeCalculateExpenseTaxReq(
  input: {
    feroEntity: ferovinum_app_db.FeroEntity,
    organisationId: ferovinum_app_db.OrganisationId,
    calculationDate: common.LocalDate,
    expenseTypeCodes: ferovinum_app_db.ExpenseTypeCode[],
  }
): CalculateExpenseTaxReq {
  return {
    feroEntity: input.feroEntity,
    organisationId: input.organisationId,
    calculationDate: input.calculationDate,
    expenseTypeCodes: input.expenseTypeCodes,
  };
}

const CalculateExpenseTaxReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[{"value":"Request to calculate VAT rates for expense type codes\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"feroEntity","default":{"kind":"nothing"},"name":"feroEntity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"FeroEntity"}},"parameters":[]}},{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"calculationDate","default":{"kind":"nothing"},"name":"calculationDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseTypeCodes","default":{"kind":"nothing"},"name":"expenseTypeCodes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseTypeCode"}},"parameters":[]}]}}]}},"name":"CalculateExpenseTaxReq","version":{"kind":"nothing"}}};

export const snCalculateExpenseTaxReq: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"CalculateExpenseTaxReq"};

export function texprCalculateExpenseTaxReq(): ADL.ATypeExpr<CalculateExpenseTaxReq> {
  return {value : {typeRef : {kind: "reference", value : snCalculateExpenseTaxReq}, parameters : []}};
}

/**
 * VAT rates keyed by expense type code (rate as decimal string, e.g. "0.2")
 */
export interface CalculateExpenseTaxResp {
  rates: {[key: string]: string};
}

export function makeCalculateExpenseTaxResp(
  input: {
    rates: {[key: string]: string},
  }
): CalculateExpenseTaxResp {
  return {
    rates: input.rates,
  };
}

const CalculateExpenseTaxResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[{"value":"VAT rates keyed by expense type code (rate as decimal string, e.g. \"0.2\")\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"rates","default":{"kind":"nothing"},"name":"rates","typeExpr":{"typeRef":{"kind":"primitive","value":"StringMap"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"CalculateExpenseTaxResp","version":{"kind":"nothing"}}};

export const snCalculateExpenseTaxResp: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"CalculateExpenseTaxResp"};

export function texprCalculateExpenseTaxResp(): ADL.ATypeExpr<CalculateExpenseTaxResp> {
  return {value : {typeRef : {kind: "reference", value : snCalculateExpenseTaxResp}, parameters : []}};
}

/**
 * Human-readable breakdown of a capex application target
 */
export interface CapexApplicationLabel {
  /**
   * Friendly application type, e.g. "Organisation", "Deal Legs"
   */
  typeLabel: common_strings.StringNE;
  /**
   * Clean target name or reference list, e.g. "Acme Drinks Ltd", "DL-1, DL-2"
   */
  target: common_strings.StringNE;
}

export function makeCapexApplicationLabel(
  input: {
    typeLabel: common_strings.StringNE,
    target: common_strings.StringNE,
  }
): CapexApplicationLabel {
  return {
    typeLabel: input.typeLabel,
    target: input.target,
  };
}

const CapexApplicationLabel_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[{"value":"Human-readable breakdown of a capex application target\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"Friendly application type, e.g. \"Organisation\", \"Deal Legs\"\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"typeLabel","default":{"kind":"nothing"},"name":"typeLabel","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"value":"Clean target name or reference list, e.g. \"Acme Drinks Ltd\", \"DL-1, DL-2\"\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"target","default":{"kind":"nothing"},"name":"target","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"CapexApplicationLabel","version":{"kind":"nothing"}}};

export const snCapexApplicationLabel: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"CapexApplicationLabel"};

export function texprCapexApplicationLabel(): ADL.ATypeExpr<CapexApplicationLabel> {
  return {value : {typeRef : {kind: "reference", value : snCapexApplicationLabel}, parameters : []}};
}

/**
 * Preview of a single capex item showing spread allocation
 */
export interface CapexPreviewItem {
  rowIndex: number;
  organisationName: common_strings.StringNE;
  expenseTypeCode: ferovinum_app_db.ExpenseTypeCode;
  description: common_strings.StringNE;
  totalCost: common.BigDecimal;
  currency: ferovinum_app_db.Currency;
  /**
   * Vendor name from the expense entry
   */
  vendor: common_strings.StringNE;
  /**
   * Structured label for the capex application target
   */
  applicationLabel: CapexApplicationLabel;
  capexConfig: ExpenseCapexConfig;
  dealLegSpreads: CapexDealLegSpread[];
}

export function makeCapexPreviewItem(
  input: {
    rowIndex: number,
    organisationName: common_strings.StringNE,
    expenseTypeCode: ferovinum_app_db.ExpenseTypeCode,
    description: common_strings.StringNE,
    totalCost: common.BigDecimal,
    currency: ferovinum_app_db.Currency,
    vendor: common_strings.StringNE,
    applicationLabel: CapexApplicationLabel,
    capexConfig: ExpenseCapexConfig,
    dealLegSpreads: CapexDealLegSpread[],
  }
): CapexPreviewItem {
  return {
    rowIndex: input.rowIndex,
    organisationName: input.organisationName,
    expenseTypeCode: input.expenseTypeCode,
    description: input.description,
    totalCost: input.totalCost,
    currency: input.currency,
    vendor: input.vendor,
    applicationLabel: input.applicationLabel,
    capexConfig: input.capexConfig,
    dealLegSpreads: input.dealLegSpreads,
  };
}

const CapexPreviewItem_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[{"value":"Preview of a single capex item showing spread allocation\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"rowIndex","default":{"kind":"nothing"},"name":"rowIndex","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"organisationName","default":{"kind":"nothing"},"name":"organisationName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseTypeCode","default":{"kind":"nothing"},"name":"expenseTypeCode","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseTypeCode"}},"parameters":[]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"totalCost","default":{"kind":"nothing"},"name":"totalCost","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Currency"}},"parameters":[]}},{"annotations":[{"value":"Vendor name from the expense entry\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"vendor","default":{"kind":"nothing"},"name":"vendor","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"value":"Structured label for the capex application target\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"applicationLabel","default":{"kind":"nothing"},"name":"applicationLabel","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"CapexApplicationLabel"}},"parameters":[]}},{"annotations":[],"serializedName":"capexConfig","default":{"kind":"nothing"},"name":"capexConfig","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"ExpenseCapexConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"dealLegSpreads","default":{"kind":"nothing"},"name":"dealLegSpreads","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"CapexDealLegSpread"}},"parameters":[]}]}}]}},"name":"CapexPreviewItem","version":{"kind":"nothing"}}};

export const snCapexPreviewItem: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"CapexPreviewItem"};

export function texprCapexPreviewItem(): ADL.ATypeExpr<CapexPreviewItem> {
  return {value : {typeRef : {kind: "reference", value : snCapexPreviewItem}, parameters : []}};
}

export interface CapexDealLegSpread {
  dealLegIdentifier: common_strings.StringNE;
  dealNumber: common_strings.StringNE;
  productId: ferovinum_app_db.ProductId;
  productCode: common_strings.StringNE;
  /**
   * Unit of measurement label: Singles, LPA, or Hectolitres
   */
  unitType: common_strings.StringNE;
  spreadQuantity: common.BigDecimal;
  costPerUnit: common.BigDecimal;
  costTotal: common.BigDecimal;
}

export function makeCapexDealLegSpread(
  input: {
    dealLegIdentifier: common_strings.StringNE,
    dealNumber: common_strings.StringNE,
    productId: ferovinum_app_db.ProductId,
    productCode: common_strings.StringNE,
    unitType: common_strings.StringNE,
    spreadQuantity: common.BigDecimal,
    costPerUnit: common.BigDecimal,
    costTotal: common.BigDecimal,
  }
): CapexDealLegSpread {
  return {
    dealLegIdentifier: input.dealLegIdentifier,
    dealNumber: input.dealNumber,
    productId: input.productId,
    productCode: input.productCode,
    unitType: input.unitType,
    spreadQuantity: input.spreadQuantity,
    costPerUnit: input.costPerUnit,
    costTotal: input.costTotal,
  };
}

const CapexDealLegSpread_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"dealLegIdentifier","default":{"kind":"nothing"},"name":"dealLegIdentifier","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"dealNumber","default":{"kind":"nothing"},"name":"dealNumber","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"productId","default":{"kind":"nothing"},"name":"productId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductId"}},"parameters":[]}},{"annotations":[],"serializedName":"productCode","default":{"kind":"nothing"},"name":"productCode","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"value":"Unit of measurement label: Singles, LPA, or Hectolitres\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"unitType","default":{"kind":"nothing"},"name":"unitType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"spreadQuantity","default":{"kind":"nothing"},"name":"spreadQuantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"costPerUnit","default":{"kind":"nothing"},"name":"costPerUnit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"costTotal","default":{"kind":"nothing"},"name":"costTotal","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"CapexDealLegSpread","version":{"kind":"nothing"}}};

export const snCapexDealLegSpread: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"CapexDealLegSpread"};

export function texprCapexDealLegSpread(): ADL.ATypeExpr<CapexDealLegSpread> {
  return {value : {typeRef : {kind: "reference", value : snCapexDealLegSpread}, parameters : []}};
}

/**
 * Preview of a recharge invoice group
 */
export interface RechargePreviewGroup {
  previewKey: common_strings.StringNE;
  organisationName: common_strings.StringNE;
  currency: ferovinum_app_db.Currency;
  feroEntity: ferovinum_app_db.FeroEntity;
  bookingDate: common.LocalDate;
  dueDate: common.LocalDate;
  lineItems: RechargePreviewLineItem[];
  subtotal: common.BigDecimal;
  salesTax: (common.BigDecimal|null);
  total: common.BigDecimal;
}

export function makeRechargePreviewGroup(
  input: {
    previewKey: common_strings.StringNE,
    organisationName: common_strings.StringNE,
    currency: ferovinum_app_db.Currency,
    feroEntity: ferovinum_app_db.FeroEntity,
    bookingDate: common.LocalDate,
    dueDate: common.LocalDate,
    lineItems: RechargePreviewLineItem[],
    subtotal: common.BigDecimal,
    salesTax: (common.BigDecimal|null),
    total: common.BigDecimal,
  }
): RechargePreviewGroup {
  return {
    previewKey: input.previewKey,
    organisationName: input.organisationName,
    currency: input.currency,
    feroEntity: input.feroEntity,
    bookingDate: input.bookingDate,
    dueDate: input.dueDate,
    lineItems: input.lineItems,
    subtotal: input.subtotal,
    salesTax: input.salesTax,
    total: input.total,
  };
}

const RechargePreviewGroup_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[{"value":"Preview of a recharge invoice group\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"previewKey","default":{"kind":"nothing"},"name":"previewKey","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"organisationName","default":{"kind":"nothing"},"name":"organisationName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Currency"}},"parameters":[]}},{"annotations":[],"serializedName":"feroEntity","default":{"kind":"nothing"},"name":"feroEntity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"FeroEntity"}},"parameters":[]}},{"annotations":[],"serializedName":"bookingDate","default":{"kind":"nothing"},"name":"bookingDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"dueDate","default":{"kind":"nothing"},"name":"dueDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"lineItems","default":{"kind":"nothing"},"name":"lineItems","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"RechargePreviewLineItem"}},"parameters":[]}]}},{"annotations":[],"serializedName":"subtotal","default":{"kind":"nothing"},"name":"subtotal","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"salesTax","default":{"kind":"nothing"},"name":"salesTax","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}},{"annotations":[],"serializedName":"total","default":{"kind":"nothing"},"name":"total","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"RechargePreviewGroup","version":{"kind":"nothing"}}};

export const snRechargePreviewGroup: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"RechargePreviewGroup"};

export function texprRechargePreviewGroup(): ADL.ATypeExpr<RechargePreviewGroup> {
  return {value : {typeRef : {kind: "reference", value : snRechargePreviewGroup}, parameters : []}};
}

export interface RechargePreviewLineItem {
  rowIndex: number;
  expenseTypeCode: ferovinum_app_db.ExpenseTypeCode;
  description: common_strings.StringNE;
  amount: common.BigDecimal;
  taxRate: (common.BigDecimal|null);
  taxAmount: (common.BigDecimal|null);
  vendor: (common_strings.StringNE|null);
  vendorReference: (common_strings.StringNE|null);
}

export function makeRechargePreviewLineItem(
  input: {
    rowIndex: number,
    expenseTypeCode: ferovinum_app_db.ExpenseTypeCode,
    description: common_strings.StringNE,
    amount: common.BigDecimal,
    taxRate: (common.BigDecimal|null),
    taxAmount: (common.BigDecimal|null),
    vendor: (common_strings.StringNE|null),
    vendorReference: (common_strings.StringNE|null),
  }
): RechargePreviewLineItem {
  return {
    rowIndex: input.rowIndex,
    expenseTypeCode: input.expenseTypeCode,
    description: input.description,
    amount: input.amount,
    taxRate: input.taxRate,
    taxAmount: input.taxAmount,
    vendor: input.vendor,
    vendorReference: input.vendorReference,
  };
}

const RechargePreviewLineItem_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"rowIndex","default":{"kind":"nothing"},"name":"rowIndex","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"expenseTypeCode","default":{"kind":"nothing"},"name":"expenseTypeCode","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseTypeCode"}},"parameters":[]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"amount","default":{"kind":"nothing"},"name":"amount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"taxRate","default":{"kind":"nothing"},"name":"taxRate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}},{"annotations":[],"serializedName":"taxAmount","default":{"kind":"nothing"},"name":"taxAmount","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}},{"annotations":[],"serializedName":"vendor","default":{"kind":"nothing"},"name":"vendor","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"vendorReference","default":{"kind":"nothing"},"name":"vendorReference","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"RechargePreviewLineItem","version":{"kind":"nothing"}}};

export const snRechargePreviewLineItem: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"RechargePreviewLineItem"};

export function texprRechargePreviewLineItem(): ADL.ATypeExpr<RechargePreviewLineItem> {
  return {value : {typeRef : {kind: "reference", value : snRechargePreviewLineItem}, parameters : []}};
}

/**
 * Row-level validation error
 */
export interface ExpenseRowError {
  rowIndex: number;
  column: common_strings.StringNE;
  message: common_strings.StringNE;
}

export function makeExpenseRowError(
  input: {
    rowIndex: number,
    column: common_strings.StringNE,
    message: common_strings.StringNE,
  }
): ExpenseRowError {
  return {
    rowIndex: input.rowIndex,
    column: input.column,
    message: input.message,
  };
}

const ExpenseRowError_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[{"value":"Row-level validation error\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"rowIndex","default":{"kind":"nothing"},"name":"rowIndex","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"column","default":{"kind":"nothing"},"name":"column","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"message","default":{"kind":"nothing"},"name":"message","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"ExpenseRowError","version":{"kind":"nothing"}}};

export const snExpenseRowError: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"ExpenseRowError"};

export function texprExpenseRowError(): ADL.ATypeExpr<ExpenseRowError> {
  return {value : {typeRef : {kind: "reference", value : snExpenseRowError}, parameters : []}};
}

export interface ExpensePreviewResp {
  capexPreviews: CapexPreviewItem[];
  rechargePreviews: RechargePreviewGroup[];
  errors: common_strings.StringNE[];
  rowErrors: ExpenseRowError[];
}

export function makeExpensePreviewResp(
  input: {
    capexPreviews: CapexPreviewItem[],
    rechargePreviews: RechargePreviewGroup[],
    errors: common_strings.StringNE[],
    rowErrors: ExpenseRowError[],
  }
): ExpensePreviewResp {
  return {
    capexPreviews: input.capexPreviews,
    rechargePreviews: input.rechargePreviews,
    errors: input.errors,
    rowErrors: input.rowErrors,
  };
}

const ExpensePreviewResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"capexPreviews","default":{"kind":"nothing"},"name":"capexPreviews","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"CapexPreviewItem"}},"parameters":[]}]}},{"annotations":[],"serializedName":"rechargePreviews","default":{"kind":"nothing"},"name":"rechargePreviews","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"RechargePreviewGroup"}},"parameters":[]}]}},{"annotations":[],"serializedName":"errors","default":{"kind":"nothing"},"name":"errors","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"rowErrors","default":{"kind":"nothing"},"name":"rowErrors","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"ExpenseRowError"}},"parameters":[]}]}}]}},"name":"ExpensePreviewResp","version":{"kind":"nothing"}}};

export const snExpensePreviewResp: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"ExpensePreviewResp"};

export function texprExpensePreviewResp(): ADL.ATypeExpr<ExpensePreviewResp> {
  return {value : {typeRef : {kind: "reference", value : snExpensePreviewResp}, parameters : []}};
}

export interface CapexPreviewReq {
  request: BookCapexReq;
  includeSpreadBreakdown: boolean;
}

export function makeCapexPreviewReq(
  input: {
    request: BookCapexReq,
    includeSpreadBreakdown?: boolean,
  }
): CapexPreviewReq {
  return {
    request: input.request,
    includeSpreadBreakdown: input.includeSpreadBreakdown === undefined ? false : input.includeSpreadBreakdown,
  };
}

const CapexPreviewReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"request","default":{"kind":"nothing"},"name":"request","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"BookCapexReq"}},"parameters":[]}},{"annotations":[],"serializedName":"includeSpreadBreakdown","default":{"kind":"just","value":false},"name":"includeSpreadBreakdown","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"CapexPreviewReq","version":{"kind":"nothing"}}};

export const snCapexPreviewReq: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"CapexPreviewReq"};

export function texprCapexPreviewReq(): ADL.ATypeExpr<CapexPreviewReq> {
  return {value : {typeRef : {kind: "reference", value : snCapexPreviewReq}, parameters : []}};
}

export interface CapexPreviewError {
  rowIndex: number;
  messages: common_strings.StringNE[];
}

export function makeCapexPreviewError(
  input: {
    rowIndex: number,
    messages: common_strings.StringNE[],
  }
): CapexPreviewError {
  return {
    rowIndex: input.rowIndex,
    messages: input.messages,
  };
}

const CapexPreviewError_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"rowIndex","default":{"kind":"nothing"},"name":"rowIndex","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"messages","default":{"kind":"nothing"},"name":"messages","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"CapexPreviewError","version":{"kind":"nothing"}}};

export const snCapexPreviewError: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"CapexPreviewError"};

export function texprCapexPreviewError(): ADL.ATypeExpr<CapexPreviewError> {
  return {value : {typeRef : {kind: "reference", value : snCapexPreviewError}, parameters : []}};
}

export interface CapexPreviewResp_Success {
  kind: 'success';
  value: CapexPreviewItem;
}
export interface CapexPreviewResp_Error {
  kind: 'error';
  value: CapexPreviewError;
}

export type CapexPreviewResp = CapexPreviewResp_Success | CapexPreviewResp_Error;

export interface CapexPreviewRespOpts {
  success: CapexPreviewItem;
  error: CapexPreviewError;
}

export function makeCapexPreviewResp<K extends keyof CapexPreviewRespOpts>(kind: K, value: CapexPreviewRespOpts[K]) { return {kind, value}; }

const CapexPreviewResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"CapexPreviewItem"}},"parameters":[]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"CapexPreviewError"}},"parameters":[]}}]}},"name":"CapexPreviewResp","version":{"kind":"nothing"}}};

export const snCapexPreviewResp: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"CapexPreviewResp"};

export function texprCapexPreviewResp(): ADL.ATypeExpr<CapexPreviewResp> {
  return {value : {typeRef : {kind: "reference", value : snCapexPreviewResp}, parameters : []}};
}

export interface BulkExpensePreviewReq {
  capexRequests: BookCapexReq[];
  rechargeRequests: BookRechargeReq[];
  includeSpreadBreakdown: boolean;
}

export function makeBulkExpensePreviewReq(
  input: {
    capexRequests: BookCapexReq[],
    rechargeRequests: BookRechargeReq[],
    includeSpreadBreakdown?: boolean,
  }
): BulkExpensePreviewReq {
  return {
    capexRequests: input.capexRequests,
    rechargeRequests: input.rechargeRequests,
    includeSpreadBreakdown: input.includeSpreadBreakdown === undefined ? false : input.includeSpreadBreakdown,
  };
}

const BulkExpensePreviewReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"capexRequests","default":{"kind":"nothing"},"name":"capexRequests","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"BookCapexReq"}},"parameters":[]}]}},{"annotations":[],"serializedName":"rechargeRequests","default":{"kind":"nothing"},"name":"rechargeRequests","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"BookRechargeReq"}},"parameters":[]}]}},{"annotations":[],"serializedName":"includeSpreadBreakdown","default":{"kind":"just","value":false},"name":"includeSpreadBreakdown","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"BulkExpensePreviewReq","version":{"kind":"nothing"}}};

export const snBulkExpensePreviewReq: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"BulkExpensePreviewReq"};

export function texprBulkExpensePreviewReq(): ADL.ATypeExpr<BulkExpensePreviewReq> {
  return {value : {typeRef : {kind: "reference", value : snBulkExpensePreviewReq}, parameters : []}};
}

export interface BulkExpenseCreateReq {
  capexRequests: BookCapexReq[];
  rechargeRequests: BookRechargeReq[];
}

export function makeBulkExpenseCreateReq(
  input: {
    capexRequests: BookCapexReq[],
    rechargeRequests: BookRechargeReq[],
  }
): BulkExpenseCreateReq {
  return {
    capexRequests: input.capexRequests,
    rechargeRequests: input.rechargeRequests,
  };
}

const BulkExpenseCreateReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"capexRequests","default":{"kind":"nothing"},"name":"capexRequests","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"BookCapexReq"}},"parameters":[]}]}},{"annotations":[],"serializedName":"rechargeRequests","default":{"kind":"nothing"},"name":"rechargeRequests","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.expenses","name":"BookRechargeReq"}},"parameters":[]}]}}]}},"name":"BulkExpenseCreateReq","version":{"kind":"nothing"}}};

export const snBulkExpenseCreateReq: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"BulkExpenseCreateReq"};

export function texprBulkExpenseCreateReq(): ADL.ATypeExpr<BulkExpenseCreateReq> {
  return {value : {typeRef : {kind: "reference", value : snBulkExpenseCreateReq}, parameters : []}};
}

export interface BulkExpenseCreateResp {
  capexExpenseIds: ferovinum_app_db.ExpenseId[];
  rechargeInvoiceIds: ferovinum_app_db.InvoiceId[];
  rechargeExpenseIds: ferovinum_app_db.ExpenseId[];
}

export function makeBulkExpenseCreateResp(
  input: {
    capexExpenseIds: ferovinum_app_db.ExpenseId[],
    rechargeInvoiceIds: ferovinum_app_db.InvoiceId[],
    rechargeExpenseIds: ferovinum_app_db.ExpenseId[],
  }
): BulkExpenseCreateResp {
  return {
    capexExpenseIds: input.capexExpenseIds,
    rechargeInvoiceIds: input.rechargeInvoiceIds,
    rechargeExpenseIds: input.rechargeExpenseIds,
  };
}

const BulkExpenseCreateResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.expenses","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"capexExpenseIds","default":{"kind":"nothing"},"name":"capexExpenseIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"rechargeInvoiceIds","default":{"kind":"nothing"},"name":"rechargeInvoiceIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"InvoiceId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"rechargeExpenseIds","default":{"kind":"nothing"},"name":"rechargeExpenseIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseId"}},"parameters":[]}]}}]}},"name":"BulkExpenseCreateResp","version":{"kind":"nothing"}}};

export const snBulkExpenseCreateResp: ADL.ScopedName = {moduleName:"ferovinum.app.expenses", name:"BulkExpenseCreateResp"};

export function texprBulkExpenseCreateResp(): ADL.ATypeExpr<BulkExpenseCreateResp> {
  return {value : {typeRef : {kind: "reference", value : snBulkExpenseCreateResp}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.expenses.ExpenseBookingData" : ExpenseBookingData_AST,
  "ferovinum.app.expenses.ExpenseBookingOrigin" : ExpenseBookingOrigin_AST,
  "ferovinum.app.expenses.ExpenseCapexConfig" : ExpenseCapexConfig_AST,
  "ferovinum.app.expenses.ExpenseCapexBinding" : ExpenseCapexBinding_AST,
  "ferovinum.app.expenses.RechargeBinding" : RechargeBinding_AST,
  "ferovinum.app.expenses.RechargeEntry" : RechargeEntry_AST,
  "ferovinum.app.expenses.BookRechargeReq" : BookRechargeReq_AST,
  "ferovinum.app.expenses.UpdateExpenseEntry" : UpdateExpenseEntry_AST,
  "ferovinum.app.expenses.UpdateExpensesReq" : UpdateExpensesReq_AST,
  "ferovinum.app.expenses.UpdateExpensesResp" : UpdateExpensesResp_AST,
  "ferovinum.app.expenses.CapexEntry" : CapexEntry_AST,
  "ferovinum.app.expenses.BookCapexReq" : BookCapexReq_AST,
  "ferovinum.app.expenses.BookPurchaseRequestExpensesReq" : BookPurchaseRequestExpensesReq_AST,
  "ferovinum.app.expenses.DeleteCapexReq" : DeleteCapexReq_AST,
  "ferovinum.app.expenses.BookRechargeResp" : BookRechargeResp_AST,
  "ferovinum.app.expenses.BookCapexResp" : BookCapexResp_AST,
  "ferovinum.app.expenses.DeleteCapexResp" : DeleteCapexResp_AST,
  "ferovinum.app.expenses.BookPurchaseRequestExpensesResp" : BookPurchaseRequestExpensesResp_AST,
  "ferovinum.app.expenses.SortDirection" : SortDirection_AST,
  "ferovinum.app.expenses.SortParam" : SortParam_AST,
  "ferovinum.app.expenses.PaginationParam" : PaginationParam_AST,
  "ferovinum.app.expenses.ExpenseVendorListReq" : ExpenseVendorListReq_AST,
  "ferovinum.app.expenses.CapexCsvReportReq" : CapexCsvReportReq_AST,
  "ferovinum.app.expenses.RechargeCsvReportReq" : RechargeCsvReportReq_AST,
  "ferovinum.app.expenses.CapexListSortField" : CapexListSortField_AST,
  "ferovinum.app.expenses.CapexListFilter" : CapexListFilter_AST,
  "ferovinum.app.expenses.CapexListReq" : CapexListReq_AST,
  "ferovinum.app.expenses.CapexListItem" : CapexListItem_AST,
  "ferovinum.app.expenses.RechargePaymentStatus" : RechargePaymentStatus_AST,
  "ferovinum.app.expenses.RechargeStatusEvent" : RechargeStatusEvent_AST,
  "ferovinum.app.expenses.ExpenseDocument" : ExpenseDocument_AST,
  "ferovinum.app.expenses.RechargeSummaryEntry" : RechargeSummaryEntry_AST,
  "ferovinum.app.expenses.RechargeSummaryResp" : RechargeSummaryResp_AST,
  "ferovinum.app.expenses.RechargeListSortField" : RechargeListSortField_AST,
  "ferovinum.app.expenses.RechargeListTab" : RechargeListTab_AST,
  "ferovinum.app.expenses.RechargeListFilter" : RechargeListFilter_AST,
  "ferovinum.app.expenses.RechargeListReq" : RechargeListReq_AST,
  "ferovinum.app.expenses.RechargeListItem" : RechargeListItem_AST,
  "ferovinum.app.expenses.RechargeBalanceSummaryItem" : RechargeBalanceSummaryItem_AST,
  "ferovinum.app.expenses.RechargeMarkPaidReq" : RechargeMarkPaidReq_AST,
  "ferovinum.app.expenses.RechargeCancelReq" : RechargeCancelReq_AST,
  "ferovinum.app.expenses.CapexSummaryOrigin" : CapexSummaryOrigin_AST,
  "ferovinum.app.expenses.CapexSummaryDescription" : CapexSummaryDescription_AST,
  "ferovinum.app.expenses.CapexSummaryStatusEvent" : CapexSummaryStatusEvent_AST,
  "ferovinum.app.expenses.CapexSummaryResp" : CapexSummaryResp_AST,
  "ferovinum.app.expenses.ExpenseListSettlementMethod" : ExpenseListSettlementMethod_AST,
  "ferovinum.app.expenses.ExpenseListSortField" : ExpenseListSortField_AST,
  "ferovinum.app.expenses.ExpenseListFilter" : ExpenseListFilter_AST,
  "ferovinum.app.expenses.ExpenseListReq" : ExpenseListReq_AST,
  "ferovinum.app.expenses.ExpenseRelatesTo" : ExpenseRelatesTo_AST,
  "ferovinum.app.expenses.ExpenseListItem" : ExpenseListItem_AST,
  "ferovinum.app.expenses.ExpenseCsvReportReq" : ExpenseCsvReportReq_AST,
  "ferovinum.app.expenses.CalculateExpenseTaxReq" : CalculateExpenseTaxReq_AST,
  "ferovinum.app.expenses.CalculateExpenseTaxResp" : CalculateExpenseTaxResp_AST,
  "ferovinum.app.expenses.CapexApplicationLabel" : CapexApplicationLabel_AST,
  "ferovinum.app.expenses.CapexPreviewItem" : CapexPreviewItem_AST,
  "ferovinum.app.expenses.CapexDealLegSpread" : CapexDealLegSpread_AST,
  "ferovinum.app.expenses.RechargePreviewGroup" : RechargePreviewGroup_AST,
  "ferovinum.app.expenses.RechargePreviewLineItem" : RechargePreviewLineItem_AST,
  "ferovinum.app.expenses.ExpenseRowError" : ExpenseRowError_AST,
  "ferovinum.app.expenses.ExpensePreviewResp" : ExpensePreviewResp_AST,
  "ferovinum.app.expenses.CapexPreviewReq" : CapexPreviewReq_AST,
  "ferovinum.app.expenses.CapexPreviewError" : CapexPreviewError_AST,
  "ferovinum.app.expenses.CapexPreviewResp" : CapexPreviewResp_AST,
  "ferovinum.app.expenses.BulkExpensePreviewReq" : BulkExpensePreviewReq_AST,
  "ferovinum.app.expenses.BulkExpenseCreateReq" : BulkExpenseCreateReq_AST,
  "ferovinum.app.expenses.BulkExpenseCreateResp" : BulkExpenseCreateResp_AST
};
